export const _airlines_list = [
    "Southwest - SWA",
    "American Airlines - AAL",
    "Delta - DAL",
    "SkyWest - SKW",
    "United - UAL",
    "JetBlue - JBU",
    "Alaska Airlines - ASA",
    "ExpressJet - ASQ",
    "Frontier - FFT",
    "Hawaiian Airlines - HAL",
    "Ryanair - RYR",
    "IndiGo - IGO",
    "EasyJet - EZY",
    "Turkish Airlines - THY",
    "Lufthansa - DLH",
    "Envoy Air - ENY",
    "Republic - RPA",
    "PSA Airlines - JIA",
    "NetJets Aviation - EJA",
    "Azul Brazilian Airlines - AZU",
    "British Airways - BAW",
    "Aeroflot - AFL",
    "Endeavor Air - EDV",
    "Air France - AFR",
    "Air China - CCA",
    "Gol Transportes Aereos - GLO",
    "Spirit - NKS",
    "LATAM Brasil - TAM",
    "Japan Airlines - JAL",
    "Mesa - ASH",
    "KLM - KLM",
    "Jazz - JZA",
    "Wizz Air - WZZ",
    "Saudia - SVA",
    "Qatar Airways - QTR",
    "Lion Air - LNI",
    "SpiceJet - SEJ",
    "SAS - SAS",
    "FedEx - FDX",
    "AirAsia - AXM",
    "All Nippon - ANA",
    "Emirates - UAE",
    "Avianca - AVA",
    "Air New Zealand - ANZ",
    "Pegasus Airlines - PGT",
    "Vueling Airlines - VLG",
    "Air India - AIC",
    "Cape Air - KAP",
    "Virgin Australia - VOZ",
    "Virgin Atlantic - VIR",
    "Air Canada - ACA",
    "Korean Air - KAL",
    "WestJet - WJA",
    "Breeze Airways - MXY",
    "Aer Lingus - EIN"
];

export const _airports_list = [
    {
        "iata": "JEG",
        "lon": "-52.75",
        "iso": "GL",
        "status": 1,
        "name": "Aasiaat Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "68.7",
        "size": "medium"
    },
    {
        "iata": "YXX",
        "lon": "-122.361946",
        "iso": "CA",
        "status": 1,
        "name": "Abbotsford Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.025555",
        "size": "medium"
    },
    {
        "iata": "SNU",
        "lon": "-79.94194",
        "iso": "CU",
        "status": 1,
        "name": "Abel Santamaria Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "22.491943",
        "size": "medium"
    },
    {
        "iata": "ABR",
        "lon": "-98.42611",
        "iso": "US",
        "status": 1,
        "name": "Aberdeen Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.4525",
        "size": "medium"
    },
    {
        "iata": "ABI",
        "lon": "-99.679726",
        "iso": "US",
        "status": 1,
        "name": "Abilene Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.409443",
        "size": "medium"
    },
    {
        "iata": "SPI",
        "lon": "-89.67889",
        "iso": "US",
        "status": 1,
        "name": "Abraham Lincoln Capital Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.844166",
        "size": "large"
    },
    {
        "iata": "ARA",
        "lon": "-91.88389",
        "iso": "US",
        "status": 1,
        "name": "Acadiana Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "30.037779",
        "size": "medium"
    },
    {
        "iata": "ADK",
        "lon": "-176.64473",
        "iso": "US",
        "status": 1,
        "name": "Adak Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.88278",
        "size": "medium"
    },
    {
        "iata": "LIT",
        "lon": "-92.221375",
        "iso": "US",
        "status": 1,
        "name": "Adams Field",
        "continent": "NA",
        "type": "airport",
        "lat": "34.727432",
        "size": "large"
    },
    {
        "iata": "SLK",
        "lon": "-74.206665",
        "iso": "US",
        "status": 1,
        "name": "Adirondack Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.38278",
        "size": "medium"
    },
    {
        "iata": "TTQ",
        "lon": "-83.51667",
        "iso": "CR",
        "status": 1,
        "name": "Aerotortuguero Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "10.566667",
        "size": "medium"
    },
    {
        "iata": "LAK",
        "lon": "-134.98584",
        "iso": "CA",
        "status": 1,
        "name": "Aklavik Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "68.22222",
        "size": "medium"
    },
    {
        "iata": "CAK",
        "lon": "-81.43583",
        "iso": "US",
        "status": 1,
        "name": "Akron Canton Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.914963",
        "size": "medium"
    },
    {
        "iata": "AKC",
        "lon": "-81.46778",
        "iso": "US",
        "status": 1,
        "name": "Akron Fulton International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.04",
        "size": "medium"
    },
    {
        "iata": "AKV",
        "lon": "-78.583336",
        "iso": "CA",
        "status": 1,
        "name": "Akulivik Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.733334",
        "size": "medium"
    },
    {
        "iata": "ALM",
        "lon": "-105.985275",
        "iso": "US",
        "status": 1,
        "name": "Alamogordo White Sands Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.845833",
        "size": "medium"
    },
    {
        "iata": "ALB",
        "lon": "-73.809555",
        "iso": "US",
        "status": 1,
        "name": "Albany International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.745277",
        "size": "medium"
    },
    {
        "iata": "TND",
        "lon": "-80.0",
        "iso": "CU",
        "status": 1,
        "name": "Alberto Delgado Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.8",
        "size": "medium"
    },
    {
        "iata": "ABQ",
        "lon": "-106.617195",
        "iso": "US",
        "status": 1,
        "name": "Albuquerque International Sunport Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.049625",
        "size": "large"
    },
    {
        "iata": "WKK",
        "lon": "-158.61111",
        "iso": "US",
        "status": 1,
        "name": "Aleknagik / New Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "59.27778",
        "size": "medium"
    },
    {
        "iata": "YLT",
        "lon": "-62.283333",
        "iso": "CA",
        "status": 1,
        "name": "Alert Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "82.51667",
        "size": "medium"
    },
    {
        "iata": "YAL",
        "lon": "-126.916664",
        "iso": "CA",
        "status": 1,
        "name": "Alert Bay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.583332",
        "size": "medium"
    },
    {
        "iata": "AEX",
        "lon": "-92.53958",
        "iso": "US",
        "status": 1,
        "name": "Alexandria International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "31.321268",
        "size": "medium"
    },
    {
        "iata": "ALI",
        "lon": "-98.066666",
        "iso": "US",
        "status": 1,
        "name": "Alice International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "27.75",
        "size": "medium"
    },
    {
        "iata": "AGC",
        "lon": "-79.93",
        "iso": "US",
        "status": 1,
        "name": "Allegheny County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.35472",
        "size": "medium"
    },
    {
        "iata": "BIG",
        "lon": "-145.719",
        "iso": "US",
        "status": 1,
        "name": "Allen Army Airfield",
        "continent": "NA",
        "type": "airport",
        "lat": "63.99458",
        "size": "medium"
    },
    {
        "iata": "YTF",
        "lon": "-71.642715",
        "iso": "CA",
        "status": 1,
        "name": "Alma Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.509655",
        "size": "medium"
    },
    {
        "iata": "CTD",
        "lon": "-80.433334",
        "iso": "PA",
        "status": 1,
        "name": "Alonso Valderrama Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "7.966667",
        "size": "medium"
    },
    {
        "iata": "APN",
        "lon": "-83.55583",
        "iso": "US",
        "status": 1,
        "name": "Alpena County Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.08167",
        "size": "medium"
    },
    {
        "iata": "AOO",
        "lon": "-78.32",
        "iso": "US",
        "status": 1,
        "name": "Altoona Blair County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.297222",
        "size": "medium"
    },
    {
        "iata": "TPQ",
        "lon": "-104.9",
        "iso": "MX",
        "status": 1,
        "name": "Amado Nervo National Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.5",
        "size": "medium"
    },
    {
        "iata": "ABL",
        "lon": "-157.84584",
        "iso": "US",
        "status": 1,
        "name": "Ambler Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "67.0875",
        "size": "medium"
    },
    {
        "iata": "YEY",
        "lon": "-78.25",
        "iso": "CA",
        "status": 1,
        "name": "Amos Magny Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.552223",
        "size": "medium"
    },
    {
        "iata": "AKP",
        "lon": "-151.74",
        "iso": "US",
        "status": 1,
        "name": "Anaktuvuk Pass Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "68.1375",
        "size": "medium"
    },
    {
        "iata": "AND",
        "lon": "-82.71",
        "iso": "US",
        "status": 1,
        "name": "Anderson Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "34.49361",
        "size": "medium"
    },
    {
        "iata": "ADW",
        "lon": "-76.86667",
        "iso": "US",
        "status": 1,
        "name": "Andrews Air Force Base",
        "continent": "NA",
        "type": "airport",
        "lat": "38.816666",
        "size": "large"
    },
    {
        "iata": "ASD",
        "lon": "-77.79611",
        "iso": "BS",
        "status": 1,
        "name": "Andros Town Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "24.697779",
        "size": "medium"
    },
    {
        "iata": "ANI",
        "lon": "-159.53697",
        "iso": "US",
        "status": 1,
        "name": "Aniak Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "61.574398",
        "size": "medium"
    },
    {
        "iata": "ANN",
        "lon": "-131.57056",
        "iso": "US",
        "status": 1,
        "name": "Annette Island Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.036945",
        "size": "medium"
    },
    {
        "iata": "ANB",
        "lon": "-85.855835",
        "iso": "US",
        "status": 1,
        "name": "Anniston Metropolitan Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.59028",
        "size": "medium"
    },
    {
        "iata": "SCU",
        "lon": "-75.83583",
        "iso": "CU",
        "status": 1,
        "name": "Antonio Maceo International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.969168",
        "size": "medium"
    },
    {
        "iata": "ARE",
        "lon": "-66.675835",
        "iso": "PR",
        "status": 1,
        "name": "Antonio Nery Juarbe Pol Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.45",
        "size": "medium"
    },
    {
        "iata": "ANV",
        "lon": "-160.18889",
        "iso": "US",
        "status": 1,
        "name": "Anvik Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.647778",
        "size": "medium"
    },
    {
        "iata": "ACV",
        "lon": "-124.106926",
        "iso": "US",
        "status": 1,
        "name": "Arcata Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.970913",
        "size": "medium"
    },
    {
        "iata": "ARC",
        "lon": "-145.52444",
        "iso": "US",
        "status": 1,
        "name": "Arctic Village Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "68.1375",
        "size": "medium"
    },
    {
        "iata": "TJP",
        "lon": "-66.563545",
        "iso": "PR",
        "status": 1,
        "name": "Areopuerto Internacional Michael Gonzalez",
        "continent": "NA",
        "type": "airport",
        "lat": "18.010702",
        "size": "large"
    },
    {
        "iata": "YYW",
        "lon": "-88.91173",
        "iso": "CA",
        "status": 1,
        "name": "Armstrong Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.29431",
        "size": "medium"
    },
    {
        "iata": "LBE",
        "lon": "-79.40855",
        "iso": "US",
        "status": 1,
        "name": "Arnold Palmer Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.272926",
        "size": "medium"
    },
    {
        "iata": "EPS",
        "lon": "-69.5",
        "iso": "DO",
        "status": 1,
        "name": "Arroyo Barril International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.25",
        "size": "medium"
    },
    {
        "iata": "ATC",
        "lon": "-75.67139",
        "iso": "BS",
        "status": 1,
        "name": "Arthur's Town Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "24.62861",
        "size": "medium"
    },
    {
        "iata": "YEK",
        "lon": "-94.05",
        "iso": "CA",
        "status": 1,
        "name": "Arviat Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "61.11667",
        "size": "medium"
    },
    {
        "iata": "AVL",
        "lon": "-82.537315",
        "iso": "US",
        "status": 1,
        "name": "Asheville Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.43508",
        "size": "large"
    },
    {
        "iata": "AHN",
        "lon": "-83.32472",
        "iso": "US",
        "status": 1,
        "name": "Athens Ben Epps Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.95195",
        "size": "medium"
    },
    {
        "iata": "YIB",
        "lon": "-91.61667",
        "iso": "CA",
        "status": 1,
        "name": "Atikokan Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.75",
        "size": "medium"
    },
    {
        "iata": "ACY",
        "lon": "-74.572235",
        "iso": "US",
        "status": 1,
        "name": "Atlantic City International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.450703",
        "size": "medium"
    },
    {
        "iata": "ATK",
        "lon": "-157.33333",
        "iso": "US",
        "status": 1,
        "name": "Atqasuk Edward Burnell Sr Memorial Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "70.5",
        "size": "medium"
    },
    {
        "iata": "YAT",
        "lon": "-82.4",
        "iso": "CA",
        "status": 1,
        "name": "Attawapiskat Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.941666",
        "size": "medium"
    },
    {
        "iata": "AGS",
        "lon": "-81.973434",
        "iso": "US",
        "status": 1,
        "name": "Augusta Regional At Bush Field",
        "continent": "NA",
        "type": "airport",
        "lat": "33.373665",
        "size": "large"
    },
    {
        "iata": "AUG",
        "lon": "-69.79667",
        "iso": "US",
        "status": 1,
        "name": "Augusta State Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.318054",
        "size": "medium"
    },
    {
        "iata": "MGA",
        "lon": "-86.171265",
        "iso": "NI",
        "status": 1,
        "name": "Augusto C. Sandino (Managua) International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "12.144838",
        "size": "medium"
    },
    {
        "iata": "YPJ",
        "lon": "-69.666664",
        "iso": "CA",
        "status": 1,
        "name": "Aupaluk Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "59.3",
        "size": "medium"
    },
    {
        "iata": "AUS",
        "lon": "-97.66706",
        "iso": "US",
        "status": 1,
        "name": "Austin Bergstrom International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "30.202545",
        "size": "large"
    },
    {
        "iata": "GRB",
        "lon": "-88.121895",
        "iso": "US",
        "status": 1,
        "name": "Austin Straubel International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.492847",
        "size": "large"
    },
    {
        "iata": "YBC",
        "lon": "-68.26667",
        "iso": "CA",
        "status": 1,
        "name": "Baie Comeau Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.2",
        "size": "medium"
    },
    {
        "iata": "YBK",
        "lon": "-96.083336",
        "iso": "CA",
        "status": 1,
        "name": "Baker Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.3",
        "size": "medium"
    },
    {
        "iata": "BWI",
        "lon": "-76.66894",
        "iso": "US",
        "status": 1,
        "name": "Baltimore/Washington International Thurgood Marshal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.179527",
        "size": "large"
    },
    {
        "iata": "BGR",
        "lon": "-68.82102",
        "iso": "US",
        "status": 1,
        "name": "Bangor International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.812298",
        "size": "large"
    },
    {
        "iata": "BKH",
        "lon": "-159.71666",
        "iso": "US",
        "status": 1,
        "name": "Barking Sands Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.966667",
        "size": "medium"
    },
    {
        "iata": "PAH",
        "lon": "-88.7725",
        "iso": "US",
        "status": 1,
        "name": "Barkley Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.06111",
        "size": "medium"
    },
    {
        "iata": "BAD",
        "lon": "-93.666664",
        "iso": "US",
        "status": 1,
        "name": "Barksdale Air Force Base",
        "continent": "NA",
        "type": "airport",
        "lat": "32.5",
        "size": "large"
    },
    {
        "iata": "BAF",
        "lon": "-72.71562",
        "iso": "US",
        "status": 1,
        "name": "Barnes Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.157955",
        "size": "medium"
    },
    {
        "iata": "HYA",
        "lon": "-70.280556",
        "iso": "US",
        "status": 1,
        "name": "Barnstable Municipal Boardman Polando Field",
        "continent": "NA",
        "type": "airport",
        "lat": "41.665833",
        "size": "medium"
    },
    {
        "iata": "BCL",
        "lon": "-82.96667",
        "iso": "CR",
        "status": 1,
        "name": "Barra del Colorado Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "10.833333",
        "size": "medium"
    },
    {
        "iata": "BTI",
        "lon": "-143.57834",
        "iso": "US",
        "status": 1,
        "name": "Barter Island Lrrs Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "70.13472",
        "size": "medium"
    },
    {
        "iata": "ZBF",
        "lon": "-65.73944",
        "iso": "CA",
        "status": 1,
        "name": "Bathurst Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.629166",
        "size": "medium"
    },
    {
        "iata": "BTR",
        "lon": "-91.156906",
        "iso": "US",
        "status": 1,
        "name": "Baton Rouge Metropolitan, Ryan Field",
        "continent": "NA",
        "type": "airport",
        "lat": "30.532537",
        "size": "large"
    },
    {
        "iata": "BAB",
        "lon": "-121.583336",
        "iso": "US",
        "status": 1,
        "name": "Beale Air Force Base",
        "continent": "NA",
        "type": "airport",
        "lat": "39.15",
        "size": "large"
    },
    {
        "iata": "YXQ",
        "lon": "-141.0",
        "iso": "CA",
        "status": 1,
        "name": "Beaver Creek Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.0",
        "size": "medium"
    },
    {
        "iata": "TZA",
        "lon": "-88.191666",
        "iso": "BZ",
        "status": 1,
        "name": "Belize City Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.51639",
        "size": "medium"
    },
    {
        "iata": "QBC",
        "lon": "-126.666664",
        "iso": "CA",
        "status": 1,
        "name": "Bella Coola Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.333332",
        "size": "medium"
    },
    {
        "iata": "BLI",
        "lon": "-122.53267",
        "iso": "US",
        "status": 1,
        "name": "Bellingham International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.795734",
        "size": "medium"
    },
    {
        "iata": "YBV",
        "lon": "-97.02141",
        "iso": "CA",
        "status": 1,
        "name": "Berens River Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.358696",
        "size": "medium"
    },
    {
        "iata": "BTM",
        "lon": "-112.49389",
        "iso": "US",
        "status": 1,
        "name": "Bert Mooney Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.95111",
        "size": "medium"
    },
    {
        "iata": "BET",
        "lon": "-161.83139",
        "iso": "US",
        "status": 1,
        "name": "Bethel Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.784443",
        "size": "medium"
    },
    {
        "iata": "BTT",
        "lon": "-151.52638",
        "iso": "US",
        "status": 1,
        "name": "Bettles Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "66.915276",
        "size": "medium"
    },
    {
        "iata": "BVY",
        "lon": "-70.88333",
        "iso": "US",
        "status": 1,
        "name": "Beverly Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.55",
        "size": "medium"
    },
    {
        "iata": "BYS",
        "lon": "-116.566666",
        "iso": "US",
        "status": 1,
        "name": "Bicycle Lake Army Air Field",
        "continent": "NA",
        "type": "airport",
        "lat": "35.266666",
        "size": "medium"
    },
    {
        "iata": "BGK",
        "lon": "-88.4",
        "iso": "BZ",
        "status": 1,
        "name": "Big Creek Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "16.516666",
        "size": "medium"
    },
    {
        "iata": "YTL",
        "lon": "-89.88952",
        "iso": "CA",
        "status": 1,
        "name": "Big Trout Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.81594",
        "size": "medium"
    },
    {
        "iata": "BIL",
        "lon": "-108.53723",
        "iso": "US",
        "status": 1,
        "name": "Billings Logan International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.803417",
        "size": "large"
    },
    {
        "iata": "YTZ",
        "lon": "-79.39585",
        "iso": "CA",
        "status": 1,
        "name": "Billy Bishop Toronto City Centre Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.632023",
        "size": "medium"
    },
    {
        "iata": "BHM",
        "lon": "-86.75219",
        "iso": "US",
        "status": 1,
        "name": "Birmingham-Shuttlesworth International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.560833",
        "size": "large"
    },
    {
        "iata": "FNT",
        "lon": "-83.73891",
        "iso": "US",
        "status": 1,
        "name": "Bishop International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.973812",
        "size": "medium"
    },
    {
        "iata": "BIS",
        "lon": "-100.75821",
        "iso": "US",
        "status": 1,
        "name": "Bismarck Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.77448",
        "size": "medium"
    },
    {
        "iata": "LEX",
        "lon": "-84.59792",
        "iso": "US",
        "status": 1,
        "name": "Blue Grass Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.03762",
        "size": "large"
    },
    {
        "iata": "BEF",
        "lon": "-83.76861",
        "iso": "NI",
        "status": 1,
        "name": "Bluefields Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "11.996944",
        "size": "medium"
    },
    {
        "iata": "IAN",
        "lon": "-160.43056",
        "iso": "US",
        "status": 1,
        "name": "Bob Baker Memorial Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "66.975555",
        "size": "medium"
    },
    {
        "iata": "BUR",
        "lon": "-118.35411",
        "iso": "US",
        "status": 1,
        "name": "Bob Hope Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "34.19619",
        "size": "medium"
    },
    {
        "iata": "BOC",
        "lon": "-82.251945",
        "iso": "PA",
        "status": 1,
        "name": "Bocas Del Toro International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "9.34",
        "size": "medium"
    },
    {
        "iata": "BFI",
        "lon": "-122.3037",
        "iso": "US",
        "status": 1,
        "name": "Boeing Field King County International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.5371",
        "size": "large"
    },
    {
        "iata": "BOI",
        "lon": "-116.22193",
        "iso": "US",
        "status": 1,
        "name": "Boise Air Terminal/Gowen field",
        "continent": "NA",
        "type": "airport",
        "lat": "43.569263",
        "size": "large"
    },
    {
        "iata": "YVB",
        "lon": "-65.45808",
        "iso": "CA",
        "status": 1,
        "name": "Bonaventure Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.069084",
        "size": "medium"
    },
    {
        "iata": "YBY",
        "lon": "-110.73333",
        "iso": "CA",
        "status": 1,
        "name": "Bonnyville Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.266666",
        "size": "medium"
    },
    {
        "iata": "HRO",
        "lon": "-93.155556",
        "iso": "US",
        "status": 1,
        "name": "Boone County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "36.261665",
        "size": "medium"
    },
    {
        "iata": "OCJ",
        "lon": "-76.96972",
        "iso": "JM",
        "status": 1,
        "name": "Boscobel Aerodrome",
        "continent": "NA",
        "type": "airport",
        "lat": "18.400557",
        "size": "medium"
    },
    {
        "iata": "ZBD",
        "iso": "CA",
        "status": 1,
        "name": "Boundary Bay Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "BWG",
        "lon": "-86.42222",
        "iso": "US",
        "status": 1,
        "name": "Bowling Green Warren County Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "36.962223",
        "size": "medium"
    },
    {
        "iata": "BFD",
        "lon": "-78.63944",
        "iso": "US",
        "status": 1,
        "name": "Bradford Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.802223",
        "size": "medium"
    },
    {
        "iata": "BDL",
        "lon": "-72.6847",
        "iso": "US",
        "status": 1,
        "name": "Bradley International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.92953",
        "size": "large"
    },
    {
        "iata": "YBR",
        "lon": "-99.94677",
        "iso": "CA",
        "status": 1,
        "name": "Brandon Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.908688",
        "size": "medium"
    },
    {
        "iata": "PWT",
        "lon": "-122.763336",
        "iso": "US",
        "status": 1,
        "name": "Bremerton National Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.485",
        "size": "medium"
    },
    {
        "iata": "YBT",
        "lon": "-101.67899",
        "iso": "CA",
        "status": 1,
        "name": "Brochet Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "57.88847",
        "size": "medium"
    },
    {
        "iata": "ZBM",
        "lon": "-72.833336",
        "iso": "CA",
        "status": 1,
        "name": "Bromont Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.316666",
        "size": "medium"
    },
    {
        "iata": "BRO",
        "lon": "-97.42333",
        "iso": "US",
        "status": 1,
        "name": "Brownsville South Padre Island International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.90889",
        "size": "medium"
    },
    {
        "iata": "BQK",
        "lon": "-81.48333",
        "iso": "US",
        "status": 1,
        "name": "Brunswick Golden Isles Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "31.166668",
        "size": "medium"
    },
    {
        "iata": "BKC",
        "lon": "-161.12666",
        "iso": "US",
        "status": 1,
        "name": "Buckland Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "65.97889",
        "size": "medium"
    },
    {
        "iata": "BAI",
        "lon": "-83.333336",
        "iso": "CR",
        "status": 1,
        "name": "Buenos Aires Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "9.166667",
        "size": "medium"
    },
    {
        "iata": "BUF",
        "lon": "-78.731804",
        "iso": "US",
        "status": 1,
        "name": "Buffalo Niagara International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.933826",
        "size": "large"
    },
    {
        "iata": "BKL",
        "lon": "-81.683334",
        "iso": "US",
        "status": 1,
        "name": "Burke Lakefront Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.516945",
        "size": "medium"
    },
    {
        "iata": "BTV",
        "lon": "-73.15527",
        "iso": "US",
        "status": 1,
        "name": "Burlington International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.469013",
        "size": "medium"
    },
    {
        "iata": "YDB",
        "lon": "-139.01666",
        "iso": "CA",
        "status": 1,
        "name": "Burwash Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "61.35",
        "size": "medium"
    },
    {
        "iata": "YKZ",
        "lon": "-79.36774",
        "iso": "CA",
        "status": 1,
        "name": "Buttonville Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.86131",
        "size": "medium"
    },
    {
        "iata": "FCS",
        "lon": "-104.816666",
        "iso": "US",
        "status": 1,
        "name": "Butts AAF (Fort Carson) Air Field",
        "continent": "NA",
        "type": "airport",
        "lat": "38.833332",
        "size": "medium"
    },
    {
        "iata": "CBJ",
        "lon": "-71.65",
        "iso": "DO",
        "status": 1,
        "name": "Cabo Rojo Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.933332",
        "size": "medium"
    },
    {
        "iata": "YYC",
        "lon": "-114.01055",
        "iso": "CA",
        "status": 1,
        "name": "Calgary International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.131393",
        "size": "large"
    },
    {
        "iata": "YCB",
        "lon": "-105.13333",
        "iso": "CA",
        "status": 1,
        "name": "Cambridge Bay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "69.1",
        "size": "medium"
    },
    {
        "iata": "YBL",
        "lon": "-125.26813",
        "iso": "CA",
        "status": 1,
        "name": "Campbell River Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.951725",
        "size": "medium"
    },
    {
        "iata": "DCF",
        "lon": "-61.333332",
        "iso": "DM",
        "status": 1,
        "name": "Canefield Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "15.5",
        "size": "medium"
    },
    {
        "iata": "CIW",
        "lon": "-61.316666",
        "iso": "VC",
        "status": 1,
        "name": "Canouan Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "12.7",
        "size": "medium"
    },
    {
        "iata": "CAP",
        "lon": "-72.195",
        "iso": "HT",
        "status": 1,
        "name": "Cap Haitien International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.732779",
        "size": "medium"
    },
    {
        "iata": "YTE",
        "lon": "-76.53333",
        "iso": "CA",
        "status": 1,
        "name": "Cape Dorset Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.23333",
        "size": "medium"
    },
    {
        "iata": "CGI",
        "lon": "-89.57167",
        "iso": "US",
        "status": 1,
        "name": "Cape Girardeau Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.22361",
        "size": "medium"
    },
    {
        "iata": "LUR",
        "lon": "-166.10695",
        "iso": "US",
        "status": 1,
        "name": "Cape Lisburne Lrrs Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "68.87583",
        "size": "medium"
    },
    {
        "iata": "EHM",
        "lon": "-162.06056",
        "iso": "US",
        "status": 1,
        "name": "Cape Newenham Lrrs Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.64722",
        "size": "medium"
    },
    {
        "iata": "CZF",
        "lon": "-166.03639",
        "iso": "US",
        "status": 1,
        "name": "Cape Romanzof Lrrs Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "61.781113",
        "size": "medium"
    },
    {
        "iata": "LAN",
        "lon": "-84.58958",
        "iso": "US",
        "status": 1,
        "name": "Capital City Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.774185",
        "size": "medium"
    },
    {
        "iata": "CYW",
        "lon": "-100.9",
        "iso": "MX",
        "status": 1,
        "name": "Captain Rogelio Castillo National Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.55",
        "size": "medium"
    },
    {
        "iata": "BYM",
        "lon": "-76.65",
        "iso": "CU",
        "status": 1,
        "name": "Carlos Manuel de Cespedes Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.383333",
        "size": "medium"
    },
    {
        "iata": "YRF",
        "lon": "-57.03828",
        "iso": "CA",
        "status": 1,
        "name": "Cartwright Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.682606",
        "size": "medium"
    },
    {
        "iata": "LRM",
        "lon": "-68.9",
        "iso": "DO",
        "status": 1,
        "name": "Casa De Campo International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.416668",
        "size": "medium"
    },
    {
        "iata": "CPR",
        "lon": "-106.4625",
        "iso": "US",
        "status": 1,
        "name": "Casper-Natrona County International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.90861",
        "size": "large"
    },
    {
        "iata": "YCG",
        "lon": "-117.632225",
        "iso": "CA",
        "status": 1,
        "name": "Castlegar/West Kootenay Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.295555",
        "size": "medium"
    },
    {
        "iata": "YAC",
        "lon": "-91.816666",
        "iso": "CA",
        "status": 1,
        "name": "Cat Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.716667",
        "size": "medium"
    },
    {
        "iata": "CNM",
        "lon": "-104.26278",
        "iso": "US",
        "status": 1,
        "name": "Cavern City Air Terminal",
        "continent": "NA",
        "type": "airport",
        "lat": "32.337223",
        "size": "medium"
    },
    {
        "iata": "CUK",
        "lon": "-88.02956",
        "iso": "BZ",
        "status": 1,
        "name": "Caye Caulker Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.735527",
        "size": "medium"
    },
    {
        "iata": "CYC",
        "lon": "-88.833336",
        "iso": "BZ",
        "status": 1,
        "name": "Caye Chapel Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.666668",
        "size": "medium"
    },
    {
        "iata": "CDC",
        "lon": "-113.09611",
        "iso": "US",
        "status": 1,
        "name": "Cedar City Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.7025",
        "size": "medium"
    },
    {
        "iata": "APA",
        "lon": "-104.84872",
        "iso": "US",
        "status": 1,
        "name": "Centennial Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.572124",
        "size": "medium"
    },
    {
        "iata": "BMI",
        "lon": "-88.91483",
        "iso": "US",
        "status": 1,
        "name": "Central Illinois Regional Airport at Bloomington-Normal",
        "continent": "NA",
        "type": "airport",
        "lat": "40.48401",
        "size": "large"
    },
    {
        "iata": "GRI",
        "lon": "-98.30666",
        "iso": "US",
        "status": 1,
        "name": "Central Nebraska Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.96722",
        "size": "medium"
    },
    {
        "iata": "YBG",
        "lon": "-70.98861",
        "iso": "CA",
        "status": 1,
        "name": "CFB Bagotville",
        "continent": "NA",
        "type": "airport",
        "lat": "48.322224",
        "size": "medium"
    },
    {
        "iata": "YOD",
        "lon": "-110.25",
        "iso": "CA",
        "status": 1,
        "name": "CFB Cold Lake",
        "continent": "NA",
        "type": "airport",
        "lat": "54.466667",
        "size": "medium"
    },
    {
        "iata": "YZX",
        "lon": "-118.666664",
        "iso": "CA",
        "status": 1,
        "name": "CFB Greenwood",
        "continent": "NA",
        "type": "airport",
        "lat": "49.166668",
        "size": "medium"
    },
    {
        "iata": "YTR",
        "lon": "-77.583336",
        "iso": "CA",
        "status": 1,
        "name": "CFB Trenton",
        "continent": "NA",
        "type": "airport",
        "lat": "44.1",
        "size": "medium"
    },
    {
        "iata": "AXN",
        "lon": "-95.394165",
        "iso": "US",
        "status": 1,
        "name": "Chandler Field",
        "continent": "NA",
        "type": "airport",
        "lat": "45.86722",
        "size": "medium"
    },
    {
        "iata": "YMT",
        "lon": "-74.36667",
        "iso": "CA",
        "status": 1,
        "name": "Chapais Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.916668",
        "size": "medium"
    },
    {
        "iata": "YLD",
        "lon": "-83.352776",
        "iso": "CA",
        "status": 1,
        "name": "Chapleau Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.819443",
        "size": "medium"
    },
    {
        "iata": "MKC",
        "lon": "-94.59194",
        "iso": "US",
        "status": 1,
        "name": "Charles B. Wheeler Downtown Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.12417",
        "size": "medium"
    },
    {
        "iata": "CHS",
        "lon": "-80.037155",
        "iso": "US",
        "status": 1,
        "name": "Charleston Air Force Base-International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.884354",
        "size": "large"
    },
    {
        "iata": "YML",
        "lon": "-70.166664",
        "iso": "CA",
        "status": 1,
        "name": "Charlevoix Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.65",
        "size": "medium"
    },
    {
        "iata": "YCL",
        "lon": "-66.32881",
        "iso": "CA",
        "status": 1,
        "name": "Charlo Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.99093",
        "size": "medium"
    },
    {
        "iata": "CLT",
        "lon": "-80.93584",
        "iso": "US",
        "status": 1,
        "name": "Charlotte Douglas International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.219166",
        "size": "large"
    },
    {
        "iata": "CHO",
        "lon": "-78.44928",
        "iso": "US",
        "status": 1,
        "name": "Charlottesville Albemarle Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.139416",
        "size": "medium"
    },
    {
        "iata": "YYG",
        "lon": "-63.131737",
        "iso": "CA",
        "status": 1,
        "name": "Charlottetown Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.285896",
        "size": "medium"
    },
    {
        "iata": "TVC",
        "lon": "-85.58035",
        "iso": "US",
        "status": 1,
        "name": "Cherry Capital Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.744083",
        "size": "medium"
    },
    {
        "iata": "YCS",
        "lon": "-90.71667",
        "iso": "CA",
        "status": 1,
        "name": "Chesterfield Inlet Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "63.333332",
        "size": "medium"
    },
    {
        "iata": "CTM",
        "lon": "-88.333336",
        "iso": "MX",
        "status": 1,
        "name": "Chetumal International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.481943",
        "size": "medium"
    },
    {
        "iata": "YCQ",
        "lon": "-121.63333",
        "iso": "CA",
        "status": 1,
        "name": "Chetwynd Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.683334",
        "size": "medium"
    },
    {
        "iata": "YHR",
        "lon": "-59.5",
        "iso": "CA",
        "status": 1,
        "name": "Chevery Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.5",
        "size": "medium"
    },
    {
        "iata": "CYS",
        "lon": "-104.816666",
        "iso": "US",
        "status": 1,
        "name": "Cheyenne Regional Jerry Olson Field",
        "continent": "NA",
        "type": "airport",
        "lat": "41.155834",
        "size": "medium"
    },
    {
        "iata": "MDW",
        "lon": "-87.74087",
        "iso": "US",
        "status": 1,
        "name": "Chicago Midway International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.788136",
        "size": "large"
    },
    {
        "iata": "ORD",
        "lon": "-87.90488",
        "iso": "US",
        "status": 1,
        "name": "Chicago O'Hare International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.976913",
        "size": "large"
    },
    {
        "iata": "RFD",
        "lon": "-89.222115",
        "iso": "US",
        "status": 1,
        "name": "Chicago Rockford International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.30364",
        "size": "large"
    },
    {
        "iata": "CZA",
        "lon": "-88.566666",
        "iso": "MX",
        "status": 1,
        "name": "Chichen Itza International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.666668",
        "size": "medium"
    },
    {
        "iata": "CIU",
        "lon": "-84.35",
        "iso": "US",
        "status": 1,
        "name": "Chippewa County International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.5",
        "size": "medium"
    },
    {
        "iata": "EAU",
        "lon": "-91.48722",
        "iso": "US",
        "status": 1,
        "name": "Chippewa Valley Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.864445",
        "size": "medium"
    },
    {
        "iata": "HIB",
        "lon": "-92.83861",
        "iso": "US",
        "status": 1,
        "name": "Chisholm Hibbing Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.38861",
        "size": "large"
    },
    {
        "iata": "YZR",
        "lon": "-82.31111",
        "iso": "CA",
        "status": 1,
        "name": "Chris Hadfield Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.997223",
        "size": "medium"
    },
    {
        "iata": "CCZ",
        "lon": "-77.881386",
        "iso": "BS",
        "status": 1,
        "name": "Chub Cay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.4175",
        "size": "medium"
    },
    {
        "iata": "YYQ",
        "lon": "-94.07449",
        "iso": "CA",
        "status": 1,
        "name": "Churchill Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.74819",
        "size": "medium"
    },
    {
        "iata": "STI",
        "lon": "-70.603355",
        "iso": "DO",
        "status": 1,
        "name": "Cibao International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.404486",
        "size": "medium"
    },
    {
        "iata": "LUK",
        "lon": "-84.666664",
        "iso": "US",
        "status": 1,
        "name": "Cincinnati Municipal Airport Lunken Field",
        "continent": "NA",
        "type": "airport",
        "lat": "39.033333",
        "size": "medium"
    },
    {
        "iata": "CVG",
        "lon": "-84.66145",
        "iso": "US",
        "status": 1,
        "name": "Cincinnati Northern Kentucky International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.0555",
        "size": "large"
    },
    {
        "iata": "COS",
        "lon": "-104.70056",
        "iso": "US",
        "status": 1,
        "name": "City of Colorado Springs Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.79713",
        "size": "large"
    },
    {
        "iata": "CME",
        "lon": "-91.802734",
        "iso": "MX",
        "status": 1,
        "name": "Ciudad del Carmen International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.65103",
        "size": "medium"
    },
    {
        "iata": "MAY",
        "lon": "-77.680275",
        "iso": "BS",
        "status": 1,
        "name": "Clarence A. Bain Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "24.289722",
        "size": "medium"
    },
    {
        "iata": "CLF",
        "lon": "-149.2125",
        "iso": "US",
        "status": 1,
        "name": "Clear Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.320335",
        "size": "medium"
    },
    {
        "iata": "CLE",
        "lon": "-81.83821",
        "iso": "US",
        "status": 1,
        "name": "Cleveland Hopkins International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.410854",
        "size": "large"
    },
    {
        "iata": "YCY",
        "lon": "-68.5",
        "iso": "CA",
        "status": 1,
        "name": "Clyde River Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "70.416664",
        "size": "medium"
    },
    {
        "iata": "EWN",
        "lon": "-77.03462",
        "iso": "US",
        "status": 1,
        "name": "Coastal Carolina Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.078342",
        "size": "medium"
    },
    {
        "iata": "CBV",
        "lon": "-90.409164",
        "iso": "GT",
        "status": 1,
        "name": "Coban Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "15.471667",
        "size": "medium"
    },
    {
        "iata": "YCN",
        "lon": "-81.01289",
        "iso": "CA",
        "status": 1,
        "name": "Cochrane Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.106018",
        "size": "medium"
    },
    {
        "iata": "CDB",
        "lon": "-162.71774",
        "iso": "US",
        "status": 1,
        "name": "Cold Bay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.20457",
        "size": "medium"
    },
    {
        "iata": "DET",
        "lon": "-83.005104",
        "iso": "US",
        "status": 1,
        "name": "Coleman A. Young Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.40932",
        "size": "medium"
    },
    {
        "iata": "CRI",
        "lon": "-74.15",
        "iso": "BS",
        "status": 1,
        "name": "Colonel Hill Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "22.75",
        "size": "medium"
    },
    {
        "iata": "CAE",
        "lon": "-81.12501",
        "iso": "US",
        "status": 1,
        "name": "Columbia Metropolitan Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.946907",
        "size": "large"
    },
    {
        "iata": "COU",
        "lon": "-92.21917",
        "iso": "US",
        "status": 1,
        "name": "Columbia Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.81361",
        "size": "medium"
    },
    {
        "iata": "CSG",
        "lon": "-84.94111",
        "iso": "US",
        "status": 1,
        "name": "Columbus Metropolitan Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.513332",
        "size": "medium"
    },
    {
        "iata": "YQQ",
        "lon": "-124.907814",
        "iso": "CA",
        "status": 1,
        "name": "Comox Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.705864",
        "size": "medium"
    },
    {
        "iata": "COX",
        "lon": "-77.583336",
        "iso": "BS",
        "status": 1,
        "name": "Congo Town Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "24.15",
        "size": "medium"
    },
    {
        "iata": "YZS",
        "lon": "-83.36667",
        "iso": "CA",
        "status": 1,
        "name": "Coral Harbour Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.2",
        "size": "medium"
    },
    {
        "iata": "YCC",
        "lon": "-74.566666",
        "iso": "CA",
        "status": 1,
        "name": "Cornwall Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.1",
        "size": "medium"
    },
    {
        "iata": "XPL",
        "lon": "-87.61667",
        "iso": "HN",
        "status": 1,
        "name": "Coronel Enrique Soto Cano Air Base",
        "continent": "NA",
        "type": "airport",
        "lat": "14.416667",
        "size": "medium"
    },
    {
        "iata": "CZH",
        "lon": "-88.410675",
        "iso": "BZ",
        "status": 1,
        "name": "Corozal Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.382334",
        "size": "medium"
    },
    {
        "iata": "CRP",
        "lon": "-97.50249",
        "iso": "US",
        "status": 1,
        "name": "Corpus Christi International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "27.774813",
        "size": "large"
    },
    {
        "iata": "OTR",
        "lon": "-82.933334",
        "iso": "CR",
        "status": 1,
        "name": "Coto 47 Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "8.566667",
        "size": "medium"
    },
    {
        "iata": "CZM",
        "lon": "-86.930466",
        "iso": "MX",
        "status": 1,
        "name": "Cozumel International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.5112",
        "size": "medium"
    },
    {
        "iata": "YXC",
        "lon": "-115.787025",
        "iso": "CA",
        "status": 1,
        "name": "Cranbrook Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.61437",
        "size": "medium"
    },
    {
        "iata": "YCR",
        "lon": "-97.75144",
        "iso": "CA",
        "status": 1,
        "name": "Cross Lake (Charlie Sinclair Memorial) Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.61306",
        "size": "medium"
    },
    {
        "iata": "STT",
        "lon": "-64.969444",
        "iso": "VI",
        "status": 1,
        "name": "Cyril E. King Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.3375",
        "size": "medium"
    },
    {
        "iata": "DFW",
        "lon": "-97.036125",
        "iso": "US",
        "status": 1,
        "name": "Dallas Fort Worth International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.89746",
        "size": "large"
    },
    {
        "iata": "DAL",
        "lon": "-96.85",
        "iso": "US",
        "status": 1,
        "name": "Dallas Love Field",
        "continent": "NA",
        "type": "airport",
        "lat": "32.84391",
        "size": "large"
    },
    {
        "iata": "MSN",
        "lon": "-89.3465",
        "iso": "US",
        "status": 1,
        "name": "Dane County Regional Truax Field",
        "continent": "NA",
        "type": "airport",
        "lat": "43.136375",
        "size": "large"
    },
    {
        "iata": "DGA",
        "lon": "-88.23039",
        "iso": "BZ",
        "status": 1,
        "name": "Dangriga Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "16.982765",
        "size": "medium"
    },
    {
        "iata": "DNL",
        "lon": "-82.0392",
        "iso": "US",
        "status": 1,
        "name": "Daniel Field",
        "continent": "NA",
        "type": "airport",
        "lat": "33.468098",
        "size": "medium"
    },
    {
        "iata": "LIR",
        "lon": "-85.53839",
        "iso": "CR",
        "status": 1,
        "name": "Daniel Oduber Quiros International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "10.600005",
        "size": "medium"
    },
    {
        "iata": "DAN",
        "lon": "-79.335",
        "iso": "US",
        "status": 1,
        "name": "Danville Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "36.573055",
        "size": "medium"
    },
    {
        "iata": "YDN",
        "lon": "-100.05",
        "iso": "CA",
        "status": 1,
        "name": "Dauphin Barker Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.1",
        "size": "medium"
    },
    {
        "iata": "YDA",
        "lon": "-139.12083",
        "iso": "CA",
        "status": 1,
        "name": "Dawson City Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.041664",
        "size": "medium"
    },
    {
        "iata": "YDQ",
        "lon": "-120.183334",
        "iso": "CA",
        "status": 1,
        "name": "Dawson Creek Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.733334",
        "size": "medium"
    },
    {
        "iata": "DAB",
        "lon": "-81.06083",
        "iso": "US",
        "status": 1,
        "name": "Daytona Beach International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "29.185192",
        "size": "medium"
    },
    {
        "iata": "SCC",
        "lon": "-148.46011",
        "iso": "US",
        "status": 1,
        "name": "Deadhorse Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "70.203636",
        "size": "medium"
    },
    {
        "iata": "LGI",
        "lon": "-75.09055",
        "iso": "BS",
        "status": 1,
        "name": "Deadman's Cay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "23.179443",
        "size": "medium"
    },
    {
        "iata": "DEC",
        "lon": "-88.868614",
        "iso": "US",
        "status": 1,
        "name": "Decatur Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.834167",
        "size": "medium"
    },
    {
        "iata": "YDF",
        "lon": "-57.399727",
        "iso": "CA",
        "status": 1,
        "name": "Deer Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.21027",
        "size": "medium"
    },
    {
        "iata": "YVZ",
        "lon": "-94.5",
        "iso": "CA",
        "status": 1,
        "name": "Deer Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.666668",
        "size": "medium"
    },
    {
        "iata": "DRG",
        "lon": "-162.75989",
        "iso": "US",
        "status": 1,
        "name": "Deering Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "66.0712",
        "size": "medium"
    },
    {
        "iata": "PDK",
        "lon": "-84.30194",
        "iso": "US",
        "status": 1,
        "name": "DeKalb Peachtree Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.875557",
        "size": "medium"
    },
    {
        "iata": "NTR",
        "lon": "-100.316666",
        "iso": "MX",
        "status": 1,
        "name": "Del Norte International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.666668",
        "size": "medium"
    },
    {
        "iata": "MIE",
        "lon": "-85.39445",
        "iso": "US",
        "status": 1,
        "name": "Delaware County Johnson Field",
        "continent": "NA",
        "type": "airport",
        "lat": "40.239723",
        "size": "medium"
    },
    {
        "iata": "DEN",
        "lon": "-104.672844",
        "iso": "US",
        "status": 1,
        "name": "Denver International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.84939",
        "size": "large"
    },
    {
        "iata": "DSM",
        "lon": "-93.64809",
        "iso": "US",
        "status": 1,
        "name": "Des Moines International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.532433",
        "size": "large"
    },
    {
        "iata": "DTW",
        "lon": "-83.35605",
        "iso": "US",
        "status": 1,
        "name": "Detroit Metropolitan Wayne County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.20781",
        "size": "large"
    },
    {
        "iata": "FAJ",
        "lon": "-65.50222",
        "iso": "PR",
        "status": 1,
        "name": "Diego Jimenez Torres Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.338888",
        "size": "medium"
    },
    {
        "iata": "YDG",
        "lon": "-65.76667",
        "iso": "CA",
        "status": 1,
        "name": "Digby / Annapolis Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.61667",
        "size": "medium"
    },
    {
        "iata": "EEN",
        "lon": "-72.270836",
        "iso": "US",
        "status": 1,
        "name": "Dillant Hopkins Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.900833",
        "size": "medium"
    },
    {
        "iata": "HDH",
        "lon": "-157.96666",
        "iso": "US",
        "status": 1,
        "name": "Dillingham Airfield",
        "continent": "NA",
        "type": "airport",
        "lat": "21.466667",
        "size": "medium"
    },
    {
        "iata": "DLG",
        "lon": "-158.51472",
        "iso": "US",
        "status": 1,
        "name": "Dillingham Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "59.04246",
        "size": "medium"
    },
    {
        "iata": "DDC",
        "lon": "-99.965",
        "iso": "US",
        "status": 1,
        "name": "Dodge City Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.761665",
        "size": "medium"
    },
    {
        "iata": "YDO",
        "lon": "-72.23333",
        "iso": "CA",
        "status": 1,
        "name": "Dolbeau St Felicien Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.86667",
        "size": "medium"
    },
    {
        "iata": "GDL",
        "lon": "-103.29921",
        "iso": "MX",
        "status": 1,
        "name": "Don Miguel Hidalgo Y Costilla International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.525198",
        "size": "large"
    },
    {
        "iata": "DHN",
        "lon": "-85.44833",
        "iso": "US",
        "status": 1,
        "name": "Dothan Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "31.32",
        "size": "medium"
    },
    {
        "iata": "YZD",
        "lon": "-79.46555",
        "iso": "CA",
        "status": 1,
        "name": "Downsview Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.74278",
        "size": "medium"
    },
    {
        "iata": "FYV",
        "lon": "-94.17",
        "iso": "US",
        "status": 1,
        "name": "Drake Field",
        "continent": "NA",
        "type": "airport",
        "lat": "36.003613",
        "size": "medium"
    },
    {
        "iata": "TPL",
        "lon": "-97.409164",
        "iso": "US",
        "status": 1,
        "name": "Draughon Miller Central Texas Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "31.150278",
        "size": "medium"
    },
    {
        "iata": "YHD",
        "lon": "-92.833336",
        "iso": "CA",
        "status": 1,
        "name": "Dryden Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.783333",
        "size": "medium"
    },
    {
        "iata": "DUJ",
        "lon": "-78.89889",
        "iso": "US",
        "status": 1,
        "name": "DuBois Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.178333",
        "size": "medium"
    },
    {
        "iata": "DBQ",
        "lon": "-90.71083",
        "iso": "US",
        "status": 1,
        "name": "Dubuque Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.41",
        "size": "large"
    },
    {
        "iata": "DLH",
        "lon": "-92.18019",
        "iso": "US",
        "status": 1,
        "name": "Duluth International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.838974",
        "size": "large"
    },
    {
        "iata": "DCT",
        "lon": "-75.75",
        "iso": "BS",
        "status": 1,
        "name": "Duncan Town Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "22.25",
        "size": "medium"
    },
    {
        "iata": "POU",
        "lon": "-73.882774",
        "iso": "US",
        "status": 1,
        "name": "Dutchess County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.628056",
        "size": "medium"
    },
    {
        "iata": "SVD",
        "lon": "-61.21038",
        "iso": "VC",
        "status": 1,
        "name": "E. T. Joshua Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "13.14604",
        "size": "medium"
    },
    {
        "iata": "EGE",
        "lon": "-106.91347",
        "iso": "US",
        "status": 1,
        "name": "Eagle County Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.63988",
        "size": "medium"
    },
    {
        "iata": "SYA",
        "lon": "174.08945",
        "iso": "US",
        "status": 1,
        "name": "Eareckson Air Station",
        "continent": "NA",
        "type": "airport",
        "lat": "52.7175",
        "size": "medium"
    },
    {
        "iata": "YXR",
        "lon": "-79.851944",
        "iso": "CA",
        "status": 1,
        "name": "Earlton (Timiskaming Regional) Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.697224",
        "size": "medium"
    },
    {
        "iata": "GGG",
        "lon": "-94.71528",
        "iso": "US",
        "status": 1,
        "name": "East Texas Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.386665",
        "size": "medium"
    },
    {
        "iata": "CLL",
        "lon": "-96.36682",
        "iso": "US",
        "status": 1,
        "name": "Easterwood Field",
        "continent": "NA",
        "type": "airport",
        "lat": "30.593842",
        "size": "medium"
    },
    {
        "iata": "ZEM",
        "lon": "-78.51667",
        "iso": "CA",
        "status": 1,
        "name": "Eastmain River Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.25",
        "size": "medium"
    },
    {
        "iata": "YXD",
        "lon": "-113.51667",
        "iso": "CA",
        "status": 1,
        "name": "Edmonton City Centre (Blatchford Field) Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.566666",
        "size": "medium"
    },
    {
        "iata": "YEG",
        "lon": "-113.584045",
        "iso": "CA",
        "status": 1,
        "name": "Edmonton International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.307377",
        "size": "large"
    },
    {
        "iata": "YET",
        "lon": "-116.46667",
        "iso": "CA",
        "status": 1,
        "name": "Edson Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.583332",
        "size": "medium"
    },
    {
        "iata": "LYB",
        "lon": "-80.08472",
        "iso": "KY",
        "status": 1,
        "name": "Edward Bodden Airfield",
        "continent": "NA",
        "type": "airport",
        "lat": "19.6592",
        "size": "medium"
    },
    {
        "iata": "GAL",
        "lon": "-156.94186",
        "iso": "US",
        "status": 1,
        "name": "Edward G. Pitka Sr Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.73798",
        "size": "medium"
    },
    {
        "iata": "EII",
        "lon": "-9.433333",
        "iso": "US",
        "status": 1,
        "name": "Egegik Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.033333",
        "size": "medium"
    },
    {
        "iata": "VPS",
        "lon": "-86.54946",
        "iso": "US",
        "status": 1,
        "name": "Eglin Air Force Base",
        "continent": "NA",
        "type": "airport",
        "lat": "30.495913",
        "size": "large"
    },
    {
        "iata": "EIL",
        "lon": "-147.71666",
        "iso": "US",
        "status": 1,
        "name": "Eielson Air Force Base",
        "continent": "NA",
        "type": "airport",
        "lat": "64.85",
        "size": "medium"
    },
    {
        "iata": "YOA",
        "lon": "-110.61444",
        "iso": "CA",
        "status": 1,
        "name": "Ekati Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.69945",
        "size": "medium"
    },
    {
        "iata": "JAL",
        "lon": "-96.781944",
        "iso": "MX",
        "status": 1,
        "name": "El Lencero Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.472221",
        "size": "medium"
    },
    {
        "iata": "ELP",
        "lon": "-106.396",
        "iso": "US",
        "status": 1,
        "name": "El Paso International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "31.798948",
        "size": "medium"
    },
    {
        "iata": "SAL",
        "lon": "-89.05723",
        "iso": "SV",
        "status": 1,
        "name": "El Salvador International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "13.445126",
        "size": "medium"
    },
    {
        "iata": "EKO",
        "lon": "-115.78972",
        "iso": "US",
        "status": 1,
        "name": "Elko Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.82389",
        "size": "medium"
    },
    {
        "iata": "YEL",
        "lon": "-82.56306",
        "iso": "CA",
        "status": 1,
        "name": "Elliot Lake Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.352222",
        "size": "medium"
    },
    {
        "iata": "EDF",
        "lon": "-149.78473",
        "iso": "US",
        "status": 1,
        "name": "Elmendorf Air Force Base",
        "continent": "NA",
        "type": "airport",
        "lat": "61.250557",
        "size": "medium"
    },
    {
        "iata": "ELM",
        "lon": "-76.89586",
        "iso": "US",
        "status": 1,
        "name": "Elmira Corning Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.16304",
        "size": "medium"
    },
    {
        "iata": "ENM",
        "iso": "US",
        "status": 1,
        "name": "Emmonak Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "ONX",
        "lon": "-79.9",
        "iso": "PA",
        "status": 1,
        "name": "Enrique Adolfo Jimenez Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "9.35",
        "size": "medium"
    },
    {
        "iata": "DAV",
        "lon": "-82.433334",
        "iso": "PA",
        "status": 1,
        "name": "Enrique Malek International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "8.383333",
        "size": "medium"
    },
    {
        "iata": "OMA",
        "lon": "-95.89972",
        "iso": "US",
        "status": 1,
        "name": "Eppley Airfield",
        "continent": "NA",
        "type": "airport",
        "lat": "41.29957",
        "size": "medium"
    },
    {
        "iata": "ERI",
        "lon": "-80.18203",
        "iso": "US",
        "status": 1,
        "name": "Erie International Tom Ridge Field",
        "continent": "NA",
        "type": "airport",
        "lat": "42.08314",
        "size": "large"
    },
    {
        "iata": "PRC",
        "lon": "-112.424164",
        "iso": "US",
        "status": 1,
        "name": "Ernest A. Love Field",
        "continent": "NA",
        "type": "airport",
        "lat": "34.65",
        "size": "medium"
    },
    {
        "iata": "YEN",
        "lon": "-102.96282",
        "iso": "CA",
        "status": 1,
        "name": "Estevan Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.207542",
        "size": "medium"
    },
    {
        "iata": "MAZ",
        "lon": "-67.14889",
        "iso": "PR",
        "status": 1,
        "name": "Eugenio Maria De Hostos Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.257778",
        "size": "medium"
    },
    {
        "iata": "EVV",
        "lon": "-87.52796",
        "iso": "US",
        "status": 1,
        "name": "Evansville Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.046165",
        "size": "medium"
    },
    {
        "iata": "GGT",
        "lon": "-75.872475",
        "iso": "BS",
        "status": 1,
        "name": "Exuma International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "23.564018",
        "size": "medium"
    },
    {
        "iata": "EUX",
        "lon": "-62.97778",
        "iso": "AN",
        "status": 1,
        "name": "F. D. Roosevelt Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.493055",
        "size": "medium"
    },
    {
        "iata": "FAI",
        "lon": "-147.8668",
        "iso": "US",
        "status": 1,
        "name": "Fairbanks International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.818214",
        "size": "large"
    },
    {
        "iata": "INL",
        "lon": "-93.40417",
        "iso": "US",
        "status": 1,
        "name": "Falls International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.563057",
        "size": "medium"
    },
    {
        "iata": "ZFA",
        "lon": "-133.36667",
        "iso": "CA",
        "status": 1,
        "name": "Faro Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "63.216667",
        "size": "medium"
    },
    {
        "iata": "FAY",
        "lon": "-78.88722",
        "iso": "US",
        "status": 1,
        "name": "Fayetteville Regional Grannis Field",
        "continent": "NA",
        "type": "airport",
        "lat": "34.99132",
        "size": "medium"
    },
    {
        "iata": "CUL",
        "lon": "-107.46958",
        "iso": "MX",
        "status": 1,
        "name": "Federal de Bachigualato International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "24.76643",
        "size": "medium"
    },
    {
        "iata": "SIG",
        "lon": "-66.09971",
        "iso": "PR",
        "status": 1,
        "name": "Fernando Luis Ribas Dominicci Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.456001",
        "size": "medium"
    },
    {
        "iata": "FLG",
        "lon": "-111.67167",
        "iso": "US",
        "status": 1,
        "name": "Flagstaff Pulliam Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.13778",
        "size": "medium"
    },
    {
        "iata": "BON",
        "lon": "-68.27687",
        "iso": "AN",
        "status": 1,
        "name": "Flamingo International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "12.133403",
        "size": "medium"
    },
    {
        "iata": "YFO",
        "lon": "-101.683334",
        "iso": "CA",
        "status": 1,
        "name": "Flin Flon Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.683334",
        "size": "medium"
    },
    {
        "iata": "FLO",
        "lon": "-79.72444",
        "iso": "US",
        "status": 1,
        "name": "Florence Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "34.18889",
        "size": "medium"
    },
    {
        "iata": "ZFD",
        "lon": "-107.18119",
        "iso": "CA",
        "status": 1,
        "name": "Fond-Du-Lac Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "59.33421",
        "size": "medium"
    },
    {
        "iata": "FOE",
        "lon": "-95.6625",
        "iso": "US",
        "status": 1,
        "name": "Forbes Field",
        "continent": "NA",
        "type": "airport",
        "lat": "38.9525",
        "size": "medium"
    },
    {
        "iata": "YFE",
        "lon": "-69.066666",
        "iso": "CA",
        "status": 1,
        "name": "Forestville Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.75",
        "size": "medium"
    },
    {
        "iata": "YFA",
        "lon": "-81.59167",
        "iso": "CA",
        "status": 1,
        "name": "Fort Albany Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.24167",
        "size": "medium"
    },
    {
        "iata": "YPY",
        "lon": "-111.11406",
        "iso": "CA",
        "status": 1,
        "name": "Fort Chipewyan Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.76799",
        "size": "medium"
    },
    {
        "iata": "FOD",
        "lon": "-94.18972",
        "iso": "US",
        "status": 1,
        "name": "Fort Dodge Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.5525",
        "size": "medium"
    },
    {
        "iata": "YAG",
        "lon": "-93.44722",
        "iso": "CA",
        "status": 1,
        "name": "Fort Frances Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.65278",
        "size": "medium"
    },
    {
        "iata": "YGH",
        "lon": "-128.65",
        "iso": "CA",
        "status": 1,
        "name": "Fort Good Hope Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "66.26667",
        "size": "medium"
    },
    {
        "iata": "YFH",
        "lon": "-87.89796",
        "iso": "CA",
        "status": 1,
        "name": "Fort Hope Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.559345",
        "size": "medium"
    },
    {
        "iata": "FLL",
        "lon": "-80.144905",
        "iso": "US",
        "status": 1,
        "name": "Fort Lauderdale Hollywood International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "26.071491",
        "size": "large"
    },
    {
        "iata": "YJF",
        "lon": "-123.46667",
        "iso": "CA",
        "status": 1,
        "name": "Fort Liard Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.25",
        "size": "medium"
    },
    {
        "iata": "YMM",
        "lon": "-111.22395",
        "iso": "CA",
        "status": 1,
        "name": "Fort McMurray Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.65659",
        "size": "medium"
    },
    {
        "iata": "ZFM",
        "lon": "-134.95277",
        "iso": "CA",
        "status": 1,
        "name": "Fort Mcpherson Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "67.477776",
        "size": "medium"
    },
    {
        "iata": "YYE",
        "lon": "-122.583336",
        "iso": "CA",
        "status": 1,
        "name": "Fort Nelson Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.833332",
        "size": "medium"
    },
    {
        "iata": "YFR",
        "lon": "-113.683334",
        "iso": "CA",
        "status": 1,
        "name": "Fort Resolution Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "61.183334",
        "size": "medium"
    },
    {
        "iata": "YER",
        "lon": "-87.833336",
        "iso": "CA",
        "status": 1,
        "name": "Fort Severn Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.033333",
        "size": "medium"
    },
    {
        "iata": "YFS",
        "lon": "-121.23333",
        "iso": "CA",
        "status": 1,
        "name": "Fort Simpson Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "61.75",
        "size": "medium"
    },
    {
        "iata": "YSM",
        "lon": "-111.96667",
        "iso": "CA",
        "status": 1,
        "name": "Fort Smith Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.016666",
        "size": "medium"
    },
    {
        "iata": "FSM",
        "lon": "-94.3589",
        "iso": "US",
        "status": 1,
        "name": "Fort Smith Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.34124",
        "size": "large"
    },
    {
        "iata": "YXJ",
        "lon": "-120.73437",
        "iso": "CA",
        "status": 1,
        "name": "Fort St John Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.247883",
        "size": "medium"
    },
    {
        "iata": "FWA",
        "lon": "-85.18771",
        "iso": "US",
        "status": 1,
        "name": "Fort Wayne International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.98666",
        "size": "large"
    },
    {
        "iata": "AFW",
        "lon": "-97.316666",
        "iso": "US",
        "status": 1,
        "name": "Fort Worth Alliance Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.986668",
        "size": "large"
    },
    {
        "iata": "FTW",
        "lon": "-97.333336",
        "iso": "US",
        "status": 1,
        "name": "Fort Worth Meacham International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.75",
        "size": "large"
    },
    {
        "iata": "FYU",
        "lon": "-145.2482",
        "iso": "US",
        "status": 1,
        "name": "Fort Yukon Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "66.56981",
        "size": "medium"
    },
    {
        "iata": "TRC",
        "lon": "-103.39874",
        "iso": "MX",
        "status": 1,
        "name": "Francisco Sarabia International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.563066",
        "size": "medium"
    },
    {
        "iata": "HOG",
        "lon": "-76.315",
        "iso": "CU",
        "status": 1,
        "name": "Frank Pais International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.785278",
        "size": "medium"
    },
    {
        "iata": "MLS",
        "lon": "-105.880554",
        "iso": "US",
        "status": 1,
        "name": "Frank Wiley Field",
        "continent": "NA",
        "type": "airport",
        "lat": "46.430557",
        "size": "medium"
    },
    {
        "iata": "YFC",
        "lon": "-66.52978",
        "iso": "CA",
        "status": 1,
        "name": "Fredericton Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.87316",
        "size": "medium"
    },
    {
        "iata": "FAT",
        "lon": "-119.72024",
        "iso": "US",
        "status": 1,
        "name": "Fresno Yosemite International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "36.769623",
        "size": "medium"
    },
    {
        "iata": "SUN",
        "lon": "-114.30082",
        "iso": "US",
        "status": 1,
        "name": "Friedman Memorial Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.50647",
        "size": "medium"
    },
    {
        "iata": "GNV",
        "lon": "-82.276794",
        "iso": "US",
        "status": 1,
        "name": "Gainesville Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "29.686142",
        "size": "medium"
    },
    {
        "iata": "BZN",
        "lon": "-111.16033",
        "iso": "US",
        "status": 1,
        "name": "Gallatin Field",
        "continent": "NA",
        "type": "airport",
        "lat": "45.777687",
        "size": "medium"
    },
    {
        "iata": "GUP",
        "lon": "-108.78667",
        "iso": "US",
        "status": 1,
        "name": "Gallup Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.511112",
        "size": "medium"
    },
    {
        "iata": "GAM",
        "lon": "-171.71355",
        "iso": "US",
        "status": 1,
        "name": "Gambell Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "63.776596",
        "size": "medium"
    },
    {
        "iata": "YQX",
        "lon": "-54.56333",
        "iso": "CA",
        "status": 1,
        "name": "Gander International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.946667",
        "size": "medium"
    },
    {
        "iata": "GCK",
        "lon": "-100.72972",
        "iso": "US",
        "status": 1,
        "name": "Garden City Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.92861",
        "size": "medium"
    },
    {
        "iata": "GYY",
        "lon": "-87.416664",
        "iso": "US",
        "status": 1,
        "name": "Gary Chicago International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.61667",
        "size": "medium"
    },
    {
        "iata": "BOS",
        "lon": "-71.02018",
        "iso": "US",
        "status": 1,
        "name": "General Edward Lawrence Logan International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.36646",
        "size": "large"
    },
    {
        "iata": "MLM",
        "lon": "-101.02693",
        "iso": "MX",
        "status": 1,
        "name": "General Francisco J. Mujica International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.84351",
        "size": "medium"
    },
    {
        "iata": "TAM",
        "lon": "-97.87016",
        "iso": "MX",
        "status": 1,
        "name": "General Francisco Javier Mina International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "22.289082",
        "size": "medium"
    },
    {
        "iata": "DGO",
        "lon": "-104.525",
        "iso": "MX",
        "status": 1,
        "name": "General Guadalupe Victoria International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "24.125",
        "size": "medium"
    },
    {
        "iata": "VER",
        "lon": "-96.18321",
        "iso": "MX",
        "status": 1,
        "name": "General Heriberto Jara International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.142275",
        "size": "medium"
    },
    {
        "iata": "HMO",
        "lon": "-111.051704",
        "iso": "MX",
        "status": 1,
        "name": "General Ignacio P. Garcia International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "29.089905",
        "size": "large"
    },
    {
        "iata": "ACA",
        "lon": "-99.75459",
        "iso": "MX",
        "status": 1,
        "name": "General Juan N Alvarez International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "16.762403",
        "size": "large"
    },
    {
        "iata": "ZCL",
        "lon": "-102.55",
        "iso": "MX",
        "status": 1,
        "name": "General Leobardo C. Ruiz International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "22.8",
        "size": "medium"
    },
    {
        "iata": "REX",
        "lon": "-98.23",
        "iso": "MX",
        "status": 1,
        "name": "General Lucio Blanco International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "26.0125",
        "size": "medium"
    },
    {
        "iata": "MTY",
        "lon": "-100.114395",
        "iso": "MX",
        "status": 1,
        "name": "General Mariano Escobedo International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.77657",
        "size": "large"
    },
    {
        "iata": "CVJ",
        "lon": "-99.262276",
        "iso": "MX",
        "status": 1,
        "name": "General Mariano Matamoros Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.834608",
        "size": "medium"
    },
    {
        "iata": "MKE",
        "lon": "-87.90267",
        "iso": "US",
        "status": 1,
        "name": "General Mitchell International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.948093",
        "size": "large"
    },
    {
        "iata": "CVM",
        "lon": "-98.96528",
        "iso": "MX",
        "status": 1,
        "name": "General Pedro Jose Mendez International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "23.713888",
        "size": "medium"
    },
    {
        "iata": "MZT",
        "lon": "-106.27015",
        "iso": "MX",
        "status": 1,
        "name": "General Rafael Buelna International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "23.167315",
        "size": "medium"
    },
    {
        "iata": "CUU",
        "lon": "-105.96952",
        "iso": "MX",
        "status": 1,
        "name": "General Roberto Fierro Villalobos International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "28.704048",
        "size": "medium"
    },
    {
        "iata": "MAM",
        "lon": "-97.52361",
        "iso": "MX",
        "status": 1,
        "name": "General Servando Canales International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.770279",
        "size": "medium"
    },
    {
        "iata": "IAH",
        "lon": "-95.34",
        "iso": "US",
        "status": 1,
        "name": "George Bush Intercontinental Houston Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "29.983334",
        "size": "large"
    },
    {
        "iata": "SLU",
        "lon": "-60.99441",
        "iso": "LC",
        "status": 1,
        "name": "George F. L. Charles Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "14.020417",
        "size": "medium"
    },
    {
        "iata": "GRR",
        "lon": "-85.52974",
        "iso": "US",
        "status": 1,
        "name": "Gerald R. Ford International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.88501",
        "size": "medium"
    },
    {
        "iata": "YGQ",
        "lon": "-86.93593",
        "iso": "CA",
        "status": 1,
        "name": "Geraldton Greenstone Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.779892",
        "size": "medium"
    },
    {
        "iata": "CYB",
        "lon": "-79.87941",
        "iso": "KY",
        "status": 1,
        "name": "Gerrard Smith International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.690191",
        "size": "medium"
    },
    {
        "iata": "YGX",
        "lon": "-94.7",
        "iso": "CA",
        "status": 1,
        "name": "Gillam Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.35",
        "size": "medium"
    },
    {
        "iata": "YGM",
        "lon": "-97.0",
        "iso": "CA",
        "status": 1,
        "name": "Gimli Industrial Park Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.666668",
        "size": "medium"
    },
    {
        "iata": "YHK",
        "lon": "-95.95",
        "iso": "CA",
        "status": 1,
        "name": "Gjoa Haven Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "68.63333",
        "size": "medium"
    },
    {
        "iata": "FCA",
        "lon": "-114.25315",
        "iso": "US",
        "status": 1,
        "name": "Glacier Park International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.307304",
        "size": "medium"
    },
    {
        "iata": "YGD",
        "iso": "CA",
        "status": 1,
        "name": "Goderich Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "YGO",
        "lon": "-94.49117",
        "iso": "CA",
        "status": 1,
        "name": "Gods Lake Narrows Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.5577",
        "size": "medium"
    },
    {
        "iata": "ZGI",
        "lon": "-94.07965",
        "iso": "CA",
        "status": 1,
        "name": "Gods River Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.83914",
        "size": "medium"
    },
    {
        "iata": "GOH",
        "lon": "-51.725",
        "iso": "GL",
        "status": 1,
        "name": "Godthaab / Nuuk Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.181946",
        "size": "medium"
    },
    {
        "iata": "GLF",
        "lon": "-83.18083",
        "iso": "CR",
        "status": 1,
        "name": "Golfito Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "8.651389",
        "size": "medium"
    },
    {
        "iata": "LCE",
        "lon": "-86.85722",
        "iso": "HN",
        "status": 1,
        "name": "Goloson International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "15.740556",
        "size": "medium"
    },
    {
        "iata": "YYR",
        "lon": "-60.4124",
        "iso": "CA",
        "status": 1,
        "name": "Goose Bay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.313534",
        "size": "medium"
    },
    {
        "iata": "YZE",
        "lon": "-82.56778",
        "iso": "CA",
        "status": 1,
        "name": "Gore Bay Manitoulin Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.885277",
        "size": "medium"
    },
    {
        "iata": "GHB",
        "lon": "-76.32488",
        "iso": "BS",
        "status": 1,
        "name": "Governor's Harbour Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.280489",
        "size": "medium"
    },
    {
        "iata": "FPO",
        "lon": "-78.7052",
        "iso": "BS",
        "status": 1,
        "name": "Grand Bahama International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "26.547293",
        "size": "medium"
    },
    {
        "iata": "GCN",
        "lon": "-112.1475",
        "iso": "US",
        "status": 1,
        "name": "Grand Canyon National Park Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.951942",
        "size": "medium"
    },
    {
        "iata": "ZGF",
        "lon": "-118.433334",
        "iso": "CA",
        "status": 1,
        "name": "Grand Forks Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.016666",
        "size": "medium"
    },
    {
        "iata": "GFK",
        "lon": "-97.17587",
        "iso": "US",
        "status": 1,
        "name": "Grand Forks International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.9488",
        "size": "medium"
    },
    {
        "iata": "GJT",
        "lon": "-108.528336",
        "iso": "US",
        "status": 1,
        "name": "Grand Junction Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.122665",
        "size": "medium"
    },
    {
        "iata": "YQU",
        "lon": "-118.873604",
        "iso": "CA",
        "status": 1,
        "name": "Grande Prairie Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.177074",
        "size": "medium"
    },
    {
        "iata": "GTF",
        "lon": "-111.35636",
        "iso": "US",
        "status": 1,
        "name": "Great Falls International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.481888",
        "size": "medium"
    },
    {
        "iata": "GHC",
        "lon": "-77.84028",
        "iso": "BS",
        "status": 1,
        "name": "Great Harbour Cay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.738056",
        "size": "medium"
    },
    {
        "iata": "BGM",
        "lon": "-75.98294",
        "iso": "US",
        "status": 1,
        "name": "Greater Binghamton/Edwin A Link field",
        "continent": "NA",
        "type": "airport",
        "lat": "42.208534",
        "size": "medium"
    },
    {
        "iata": "YQM",
        "lon": "-64.68123",
        "iso": "CA",
        "status": 1,
        "name": "Greater Moncton International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.104774",
        "size": "medium"
    },
    {
        "iata": "PIA",
        "lon": "-89.69012",
        "iso": "US",
        "status": 1,
        "name": "Greater Peoria Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.66643",
        "size": "large"
    },
    {
        "iata": "ROC",
        "lon": "-77.66543",
        "iso": "US",
        "status": 1,
        "name": "Greater Rochester International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.127975",
        "size": "large"
    },
    {
        "iata": "GSP",
        "lon": "-82.21706",
        "iso": "US",
        "status": 1,
        "name": "Greenville Spartanburg International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "34.890568",
        "size": "large"
    },
    {
        "iata": "POP",
        "lon": "-70.56315",
        "iso": "DO",
        "status": 1,
        "name": "Gregorio Luperon International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.754942",
        "size": "medium"
    },
    {
        "iata": "YGZ",
        "lon": "-82.95722",
        "iso": "CA",
        "status": 1,
        "name": "Grise Fiord Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "76.41778",
        "size": "medium"
    },
    {
        "iata": "GON",
        "lon": "-72.04639",
        "iso": "US",
        "status": 1,
        "name": "Groton New London Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.328888",
        "size": "medium"
    },
    {
        "iata": "GPL",
        "lon": "-83.8",
        "iso": "CR",
        "status": 1,
        "name": "Guapiles Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "10.2",
        "size": "medium"
    },
    {
        "iata": "GPT",
        "lon": "-89.07203",
        "iso": "US",
        "status": 1,
        "name": "Gulfport Biloxi International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "30.413284",
        "size": "large"
    },
    {
        "iata": "GKN",
        "lon": "-145.45222",
        "iso": "US",
        "status": 1,
        "name": "Gulkana Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.155277",
        "size": "medium"
    },
    {
        "iata": "SBH",
        "lon": "-62.85",
        "iso": "BL",
        "status": 1,
        "name": "Gustaf III Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.9",
        "size": "medium"
    },
    {
        "iata": "BCA",
        "lon": "-74.5",
        "iso": "CU",
        "status": 1,
        "name": "Gustavo Rizo Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.35",
        "size": "medium"
    },
    {
        "iata": "GST",
        "lon": "-135.705",
        "iso": "US",
        "status": 1,
        "name": "Gustavus Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.4275",
        "size": "medium"
    },
    {
        "iata": "HGR",
        "lon": "-77.73",
        "iso": "US",
        "status": 1,
        "name": "Hagerstown Regional Richard A Henson Field",
        "continent": "NA",
        "type": "airport",
        "lat": "39.70778",
        "size": "medium"
    },
    {
        "iata": "HNS",
        "lon": "-135.52924",
        "iso": "US",
        "status": 1,
        "name": "Haines Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "59.246197",
        "size": "medium"
    },
    {
        "iata": "YHT",
        "lon": "-137.5",
        "iso": "CA",
        "status": 1,
        "name": "Haines Junction Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.75",
        "size": "medium"
    },
    {
        "iata": "YHZ",
        "lon": "-63.51425",
        "iso": "CA",
        "status": 1,
        "name": "Halifax / Stanfield International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.88496",
        "size": "large"
    },
    {
        "iata": "YUX",
        "lon": "-81.25",
        "iso": "CA",
        "status": 1,
        "name": "Hall Beach Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "68.78333",
        "size": "medium"
    },
    {
        "iata": "HNM",
        "lon": "-156.01889",
        "iso": "US",
        "status": 1,
        "name": "Hana Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.795834",
        "size": "medium"
    },
    {
        "iata": "BHB",
        "lon": "-68.361664",
        "iso": "US",
        "status": 1,
        "name": "Hancock County-Bar Harbor Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.44889",
        "size": "medium"
    },
    {
        "iata": "MDT",
        "lon": "-76.75606",
        "iso": "US",
        "status": 1,
        "name": "Harrisburg International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.196007",
        "size": "medium"
    },
    {
        "iata": "ATL",
        "lon": "-84.44403",
        "iso": "US",
        "status": 1,
        "name": "Hartsfield Jackson Atlanta International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.640068",
        "size": "large"
    },
    {
        "iata": "CUR",
        "lon": "-68.95706",
        "iso": "AN",
        "status": 1,
        "name": "Hato International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "12.184615",
        "size": "medium"
    },
    {
        "iata": "PIB",
        "lon": "-89.33667",
        "iso": "US",
        "status": 1,
        "name": "Hattiesburg Laurel Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "31.4675",
        "size": "medium"
    },
    {
        "iata": "YGV",
        "lon": "-63.583332",
        "iso": "CA",
        "status": 1,
        "name": "Havre St Pierre Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.25",
        "size": "medium"
    },
    {
        "iata": "YHY",
        "lon": "-115.778336",
        "iso": "CA",
        "status": 1,
        "name": "Hay River / Merlyn Carter Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.845554",
        "size": "medium"
    },
    {
        "iata": "FAR",
        "lon": "-96.82551",
        "iso": "US",
        "status": 1,
        "name": "Hector International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.91953",
        "size": "medium"
    },
    {
        "iata": "HLN",
        "lon": "-111.99018",
        "iso": "US",
        "status": 1,
        "name": "Helena Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.61052",
        "size": "medium"
    },
    {
        "iata": "STX",
        "lon": "-64.798615",
        "iso": "VI",
        "status": 1,
        "name": "Henry E Rohlsen Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.701944",
        "size": "medium"
    },
    {
        "iata": "VTU",
        "lon": "-76.95",
        "iso": "CU",
        "status": 1,
        "name": "Hermanos Ameijeiras Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.966667",
        "size": "medium"
    },
    {
        "iata": "UVF",
        "lon": "-60.95222",
        "iso": "LC",
        "status": 1,
        "name": "Hewanorra International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "13.735556",
        "size": "medium"
    },
    {
        "iata": "HKY",
        "lon": "-81.39167",
        "iso": "US",
        "status": 1,
        "name": "Hickory Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.73861",
        "size": "medium"
    },
    {
        "iata": "YOJ",
        "lon": "-117.168335",
        "iso": "CA",
        "status": 1,
        "name": "High Level Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.618332",
        "size": "medium"
    },
    {
        "iata": "ITO",
        "lon": "-155.03963",
        "iso": "US",
        "status": 1,
        "name": "Hilo International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.714565",
        "size": "medium"
    },
    {
        "iata": "HCR",
        "lon": "-159.77167",
        "iso": "US",
        "status": 1,
        "name": "Holy Cross Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.18889",
        "size": "medium"
    },
    {
        "iata": "HOM",
        "lon": "-151.49316",
        "iso": "US",
        "status": 1,
        "name": "Homer Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "59.64324",
        "size": "medium"
    },
    {
        "iata": "HNL",
        "lon": "-157.92166",
        "iso": "US",
        "status": 1,
        "name": "Honolulu International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.325832",
        "size": "large"
    },
    {
        "iata": "HPB",
        "lon": "-166.14586",
        "iso": "US",
        "status": 1,
        "name": "Hooper Bay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "61.525078",
        "size": "medium"
    },
    {
        "iata": "YHE",
        "lon": "-121.416664",
        "iso": "CA",
        "status": 1,
        "name": "Hope Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.416668",
        "size": "medium"
    },
    {
        "iata": "YHO",
        "lon": "-60.229443",
        "iso": "CA",
        "status": 1,
        "name": "Hopedale Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.448334",
        "size": "medium"
    },
    {
        "iata": "YHN",
        "lon": "-84.78333",
        "iso": "CA",
        "status": 1,
        "name": "Hornepayne Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.216667",
        "size": "medium"
    },
    {
        "iata": "CMX",
        "lon": "-88.48639",
        "iso": "US",
        "status": 1,
        "name": "Houghton County Memorial Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.167778",
        "size": "medium"
    },
    {
        "iata": "HSV",
        "lon": "-86.77484",
        "iso": "US",
        "status": 1,
        "name": "Huntsville International Carl T Jones Field",
        "continent": "NA",
        "type": "airport",
        "lat": "34.64857",
        "size": "large"
    },
    {
        "iata": "HON",
        "lon": "-98.22639",
        "iso": "US",
        "status": 1,
        "name": "Huron Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.38361",
        "size": "medium"
    },
    {
        "iata": "IDA",
        "lon": "-112.06751",
        "iso": "US",
        "status": 1,
        "name": "Idaho Falls Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.514854",
        "size": "medium"
    },
    {
        "iata": "YGT",
        "lon": "-81.816666",
        "iso": "CA",
        "status": 1,
        "name": "Igloolik Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "69.4",
        "size": "medium"
    },
    {
        "iata": "ZUC",
        "lon": "-91.833336",
        "iso": "CA",
        "status": 1,
        "name": "Ignace Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.5",
        "size": "medium"
    },
    {
        "iata": "CMW",
        "lon": "-77.849724",
        "iso": "CU",
        "status": 1,
        "name": "Ignacio Agramonte International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.418612",
        "size": "medium"
    },
    {
        "iata": "BDR",
        "lon": "-73.12444",
        "iso": "US",
        "status": 1,
        "name": "Igor I Sikorsky Memorial Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.164165",
        "size": "medium"
    },
    {
        "iata": "ZBF",
        "lon": "-65.73944",
        "iso": "CA",
        "status": 1,
        "name": "Ilford Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.629166",
        "size": "medium"
    },
    {
        "iata": "ILI",
        "lon": "-154.90834",
        "iso": "US",
        "status": 1,
        "name": "Iliamna Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "59.752777",
        "size": "medium"
    },
    {
        "iata": "IGA",
        "lon": "-73.666664",
        "iso": "BS",
        "status": 1,
        "name": "Inagua Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.983334",
        "size": "medium"
    },
    {
        "iata": "UTO",
        "lon": "-153.70166",
        "iso": "US",
        "status": 1,
        "name": "Indian Mountain Lrrs Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "65.99333",
        "size": "medium"
    },
    {
        "iata": "IND",
        "lon": "-86.29805",
        "iso": "US",
        "status": 1,
        "name": "Indianapolis International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.714516",
        "size": "large"
    },
    {
        "iata": "YPH",
        "lon": "-78.166664",
        "iso": "CA",
        "status": 1,
        "name": "Inukjuak Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.433334",
        "size": "medium"
    },
    {
        "iata": "YEV",
        "lon": "-133.49767",
        "iso": "CA",
        "status": 1,
        "name": "Inuvik Mike Zubko Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "68.30665",
        "size": "medium"
    },
    {
        "iata": "YFB",
        "lon": "-68.53658",
        "iso": "CA",
        "status": 1,
        "name": "Iqaluit Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "63.75175",
        "size": "medium"
    },
    {
        "iata": "YIV",
        "lon": "-94.653046",
        "iso": "CA",
        "status": 1,
        "name": "Island Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.856785",
        "size": "medium"
    },
    {
        "iata": "ITH",
        "lon": "-76.46359",
        "iso": "US",
        "status": 1,
        "name": "Ithaca Tompkins Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.49034",
        "size": "medium"
    },
    {
        "iata": "YIK",
        "lon": "-76.083336",
        "iso": "CA",
        "status": 1,
        "name": "Ivujivik Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.416668",
        "size": "medium"
    },
    {
        "iata": "ZIH",
        "lon": "-101.464066",
        "iso": "MX",
        "status": 1,
        "name": "Ixtapa Zihuatanejo International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.606783",
        "size": "medium"
    },
    {
        "iata": "IZT",
        "lon": "-95.10833",
        "iso": "MX",
        "status": 1,
        "name": "Ixtepec Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "16.569166",
        "size": "medium"
    },
    {
        "iata": "BQU",
        "lon": "-61.264168",
        "iso": "VC",
        "status": 1,
        "name": "J F Mitchell Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "12.986667",
        "size": "medium"
    },
    {
        "iata": "CEC",
        "lon": "-124.23583",
        "iso": "US",
        "status": 1,
        "name": "Jack Mc Namara Field Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.78",
        "size": "medium"
    },
    {
        "iata": "JAN",
        "lon": "-90.07496",
        "iso": "US",
        "status": 1,
        "name": "Jackson Evers International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.309895",
        "size": "large"
    },
    {
        "iata": "JAC",
        "lon": "-110.73613",
        "iso": "US",
        "status": 1,
        "name": "Jackson Hole Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.602806",
        "size": "medium"
    },
    {
        "iata": "JAX",
        "lon": "-81.68306",
        "iso": "US",
        "status": 1,
        "name": "Jacksonville International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "30.491657",
        "size": "large"
    },
    {
        "iata": "JAK",
        "lon": "-72.51861",
        "iso": "HT",
        "status": 1,
        "name": "Jacmel Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.240557",
        "size": "medium"
    },
    {
        "iata": "GDT",
        "lon": "-71.13333",
        "iso": "TC",
        "status": 1,
        "name": "JAGS McCartney International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.466667",
        "size": "medium"
    },
    {
        "iata": "CFG",
        "lon": "-80.41417",
        "iso": "CU",
        "status": 1,
        "name": "Jaime Gonzalez Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "22.15",
        "size": "medium"
    },
    {
        "iata": "DAY",
        "lon": "-84.220764",
        "iso": "US",
        "status": 1,
        "name": "James M Cox Dayton International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.898006",
        "size": "large"
    },
    {
        "iata": "YCE",
        "lon": "-81.48333",
        "iso": "CA",
        "status": 1,
        "name": "James T. Field Memorial Aerodrome",
        "continent": "NA",
        "type": "airport",
        "lat": "43.283333",
        "size": "medium"
    },
    {
        "iata": "JMS",
        "lon": "-98.67833",
        "iso": "US",
        "status": 1,
        "name": "Jamestown Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.93",
        "size": "medium"
    },
    {
        "iata": "CCC",
        "lon": "-78.32861",
        "iso": "CU",
        "status": 1,
        "name": "Jardines Del Rey Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "22.461111",
        "size": "medium"
    },
    {
        "iata": "ZJG",
        "lon": "-98.04611",
        "iso": "CA",
        "status": 1,
        "name": "Jenpeg Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.519444",
        "size": "medium"
    },
    {
        "iata": "AGU",
        "lon": "-102.31374",
        "iso": "MX",
        "status": 1,
        "name": "Jesus Teran International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.701416",
        "size": "medium"
    },
    {
        "iata": "FSD",
        "lon": "-96.73115",
        "iso": "US",
        "status": 1,
        "name": "Joe Foss Field Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.580296",
        "size": "medium"
    },
    {
        "iata": "MNI",
        "lon": "-62.233334",
        "iso": "MS",
        "status": 1,
        "name": "John A. Osborne Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "16.75",
        "size": "medium"
    },
    {
        "iata": "YHM",
        "lon": "-79.92631",
        "iso": "CA",
        "status": 1,
        "name": "John C. Munro Hamilton International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.16138",
        "size": "medium"
    },
    {
        "iata": "JFK",
        "lon": "-73.78817",
        "iso": "US",
        "status": 1,
        "name": "John F Kennedy International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.642334",
        "size": "large"
    },
    {
        "iata": "JST",
        "lon": "-78.83444",
        "iso": "US",
        "status": 1,
        "name": "John Murtha Johnstown Cambria County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.316666",
        "size": "medium"
    },
    {
        "iata": "SNA",
        "lon": "-117.860535",
        "iso": "US",
        "status": 1,
        "name": "John Wayne Airport-Orange County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.680202",
        "size": "large"
    },
    {
        "iata": "JBR",
        "lon": "-90.64833",
        "iso": "US",
        "status": 1,
        "name": "Jonesboro Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.83",
        "size": "medium"
    },
    {
        "iata": "JLN",
        "lon": "-94.49778",
        "iso": "US",
        "status": 1,
        "name": "Joplin Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.149723",
        "size": "large"
    },
    {
        "iata": "TWF",
        "lon": "-114.486664",
        "iso": "US",
        "status": 1,
        "name": "Joslin Field Magic Valley Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.481945",
        "size": "medium"
    },
    {
        "iata": "VRA",
        "lon": "-81.43694",
        "iso": "CU",
        "status": 1,
        "name": "Juan Gualberto Gomez International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "23.039896",
        "size": "large"
    },
    {
        "iata": "RTB",
        "lon": "-86.52722",
        "iso": "HN",
        "status": 1,
        "name": "Juan Manuel Galvez International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "16.318209",
        "size": "medium"
    },
    {
        "iata": "SJO",
        "lon": "-84.20408",
        "iso": "CR",
        "status": 1,
        "name": "Juan Santamaria International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "9.998238",
        "size": "medium"
    },
    {
        "iata": "JNU",
        "lon": "-134.58339",
        "iso": "US",
        "status": 1,
        "name": "Juneau International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.35932",
        "size": "medium"
    },
    {
        "iata": "OGG",
        "lon": "-156.43863",
        "iso": "US",
        "status": 1,
        "name": "Kahului Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.892883",
        "size": "medium"
    },
    {
        "iata": "AFE",
        "iso": "US",
        "status": 1,
        "name": "Kake Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "JRF",
        "iso": "US",
        "status": 1,
        "name": "Kalaeloa (John Rodgers Field) Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "AZO",
        "lon": "-85.55656",
        "iso": "US",
        "status": 1,
        "name": "Kalamazoo Battle Creek International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.239964",
        "size": "medium"
    },
    {
        "iata": "YKA",
        "lon": "-120.442024",
        "iso": "CA",
        "status": 1,
        "name": "Kamloops Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.70545",
        "size": "medium"
    },
    {
        "iata": "SFJ",
        "lon": "-50.719723",
        "iso": "GL",
        "status": 1,
        "name": "Kangerlussuaq Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "67.01222",
        "size": "medium"
    },
    {
        "iata": "XGR",
        "lon": "-65.98333",
        "iso": "CA",
        "status": 1,
        "name": "Kangiqsualujjuaq (Georges River) Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.5",
        "size": "medium"
    },
    {
        "iata": "YKG",
        "lon": "-70.0046",
        "iso": "CA",
        "status": 1,
        "name": "Kangirsuk Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.023083",
        "size": "medium"
    },
    {
        "iata": "MCI",
        "lon": "-94.719925",
        "iso": "US",
        "status": 1,
        "name": "Kansas City International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.293808",
        "size": "large"
    },
    {
        "iata": "JHM",
        "lon": "-156.67569",
        "iso": "US",
        "status": 1,
        "name": "Kapalua Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.962194",
        "size": "medium"
    },
    {
        "iata": "YYU",
        "lon": "-82.47083",
        "iso": "CA",
        "status": 1,
        "name": "Kapuskasing Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.4125",
        "size": "medium"
    },
    {
        "iata": "XKS",
        "lon": "-88.64667",
        "iso": "CA",
        "status": 1,
        "name": "Kasabonika Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.52",
        "size": "medium"
    },
    {
        "iata": "ZKE",
        "lon": "-81.333336",
        "iso": "CA",
        "status": 1,
        "name": "Kashechewan Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.333332",
        "size": "medium"
    },
    {
        "iata": "VRO",
        "lon": "-81.3",
        "iso": "CU",
        "status": 1,
        "name": "Kawama Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "23.133333",
        "size": "medium"
    },
    {
        "iata": "YLW",
        "lon": "-119.38139",
        "iso": "CA",
        "status": 1,
        "name": "Kelowna Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.95154",
        "size": "medium"
    },
    {
        "iata": "ZEE",
        "iso": "CA",
        "status": 1,
        "name": "Kelsey Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "POT",
        "lon": "-76.53555",
        "iso": "JM",
        "status": 1,
        "name": "Ken Jones Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.198334",
        "size": "medium"
    },
    {
        "iata": "ENA",
        "lon": "-151.24644",
        "iso": "US",
        "status": 1,
        "name": "Kenai Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.56521",
        "size": "medium"
    },
    {
        "iata": "YQK",
        "lon": "-94.35833",
        "iso": "CA",
        "status": 1,
        "name": "Kenora Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.7875",
        "size": "medium"
    },
    {
        "iata": "KTN",
        "lon": "-131.7087",
        "iso": "US",
        "status": 1,
        "name": "Ketchikan International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.35655",
        "size": "medium"
    },
    {
        "iata": "MEI",
        "lon": "-88.74917",
        "iso": "US",
        "status": 1,
        "name": "Key Field",
        "continent": "NA",
        "type": "airport",
        "lat": "32.337223",
        "size": "medium"
    },
    {
        "iata": "YKJ",
        "lon": "-105.61864",
        "iso": "CA",
        "status": 1,
        "name": "Key Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "57.256287",
        "size": "medium"
    },
    {
        "iata": "EYW",
        "lon": "-81.75501",
        "iso": "US",
        "status": 1,
        "name": "Key West International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "24.553574",
        "size": "medium"
    },
    {
        "iata": "YLC",
        "lon": "-69.88333",
        "iso": "CA",
        "status": 1,
        "name": "Kimmirut Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.85",
        "size": "medium"
    },
    {
        "iata": "YKY",
        "lon": "-109.17811",
        "iso": "CA",
        "status": 1,
        "name": "Kindersley Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.517605",
        "size": "medium"
    },
    {
        "iata": "AKN",
        "lon": "-156.66902",
        "iso": "US",
        "status": 1,
        "name": "King Salmon Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.68274",
        "size": "medium"
    },
    {
        "iata": "YGK",
        "lon": "-76.59366",
        "iso": "CA",
        "status": 1,
        "name": "Kingston Norman Rogers Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.219513",
        "size": "medium"
    },
    {
        "iata": "YKX",
        "lon": "-80.03333",
        "iso": "CA",
        "status": 1,
        "name": "Kirkland Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.15",
        "size": "medium"
    },
    {
        "iata": "IRK",
        "lon": "-92.54389",
        "iso": "US",
        "status": 1,
        "name": "Kirksville Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.0925",
        "size": "medium"
    },
    {
        "iata": "KVL",
        "lon": "-164.54723",
        "iso": "US",
        "status": 1,
        "name": "Kivalina Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "67.73167",
        "size": "medium"
    },
    {
        "iata": "LMT",
        "lon": "-121.73583",
        "iso": "US",
        "status": 1,
        "name": "Klamath Falls Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.163055",
        "size": "medium"
    },
    {
        "iata": "AKW",
        "lon": "49.683334",
        "iso": "US",
        "status": 1,
        "name": "Klawock Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "30.75",
        "size": "medium"
    },
    {
        "iata": "ADQ",
        "lon": "-152.51297",
        "iso": "US",
        "status": 1,
        "name": "Kodiak Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "57.755276",
        "size": "medium"
    },
    {
        "iata": "KOA",
        "lon": "-156.04108",
        "iso": "US",
        "status": 1,
        "name": "Kona International At Keahole Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.736174",
        "size": "medium"
    },
    {
        "iata": "YBB",
        "lon": "-89.85",
        "iso": "CA",
        "status": 1,
        "name": "Kugaaruk Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "68.88333",
        "size": "medium"
    },
    {
        "iata": "YCO",
        "lon": "-115.083336",
        "iso": "CA",
        "status": 1,
        "name": "Kugluktuk Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "67.833336",
        "size": "medium"
    },
    {
        "iata": "YVP",
        "lon": "-68.41798",
        "iso": "CA",
        "status": 1,
        "name": "Kuujjuaq Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.10024",
        "size": "medium"
    },
    {
        "iata": "YGW",
        "lon": "-77.76667",
        "iso": "CA",
        "status": 1,
        "name": "Kuujjuarapik Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.279167",
        "size": "medium"
    },
    {
        "iata": "BDA",
        "lon": "-64.70115",
        "iso": "BM",
        "status": 1,
        "name": "L.F. Wade International International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.35994",
        "size": "medium"
    },
    {
        "iata": "GUA",
        "lon": "-90.53068",
        "iso": "GT",
        "status": 1,
        "name": "La Aurora Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "14.588071",
        "size": "medium"
    },
    {
        "iata": "LCL",
        "lon": "-83.61667",
        "iso": "CU",
        "status": 1,
        "name": "La Coloma Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "22.283333",
        "size": "medium"
    },
    {
        "iata": "LSE",
        "lon": "-91.264336",
        "iso": "US",
        "status": 1,
        "name": "La Crosse Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.875244",
        "size": "medium"
    },
    {
        "iata": "YAH",
        "lon": "-73.65",
        "iso": "CA",
        "status": 1,
        "name": "La Grande-4 Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.75",
        "size": "medium"
    },
    {
        "iata": "LGA",
        "lon": "-73.87162",
        "iso": "US",
        "status": 1,
        "name": "La Guardia Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.774254",
        "size": "large"
    },
    {
        "iata": "JBQ",
        "lon": "-69.98144",
        "iso": "DO",
        "status": 1,
        "name": "La Isabela International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.575731",
        "size": "medium"
    },
    {
        "iata": "GJA",
        "lon": "-85.90583",
        "iso": "HN",
        "status": 1,
        "name": "La Laguna Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "16.445",
        "size": "medium"
    },
    {
        "iata": "YTM",
        "lon": "-74.75528",
        "iso": "CA",
        "status": 1,
        "name": "La Macaza / Mont-Tremblant International Inc Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.515556",
        "size": "medium"
    },
    {
        "iata": "YVC",
        "lon": "-105.26066",
        "iso": "CA",
        "status": 1,
        "name": "La Ronge Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.15126",
        "size": "medium"
    },
    {
        "iata": "ZWH",
        "iso": "CA",
        "status": 1,
        "name": "Lac Brochet Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "YAX",
        "lon": "-89.565",
        "iso": "CA",
        "status": 1,
        "name": "Lac Du Bonnet Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.251945",
        "size": "medium"
    },
    {
        "iata": "FBK",
        "lon": "-147.7",
        "iso": "US",
        "status": 1,
        "name": "Ladd AAF Airfield",
        "continent": "NA",
        "type": "airport",
        "lat": "64.833336",
        "size": "medium"
    },
    {
        "iata": "LFT",
        "lon": "-91.99327",
        "iso": "US",
        "status": 1,
        "name": "Lafayette Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "30.20851",
        "size": "large"
    },
    {
        "iata": "LCH",
        "lon": "-93.225555",
        "iso": "US",
        "status": 1,
        "name": "Lake Charles Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "30.131111",
        "size": "medium"
    },
    {
        "iata": "TVL",
        "lon": "-119.994446",
        "iso": "US",
        "status": 1,
        "name": "Lake Tahoe Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.89417",
        "size": "medium"
    },
    {
        "iata": "NEL",
        "lon": "-74.316666",
        "iso": "US",
        "status": 1,
        "name": "Lakehurst NAES /Maxfield Field",
        "continent": "NA",
        "type": "airport",
        "lat": "40.016666",
        "size": "medium"
    },
    {
        "iata": "STL",
        "lon": "-90.36587",
        "iso": "US",
        "status": 1,
        "name": "Lambert St Louis International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.74228",
        "size": "large"
    },
    {
        "iata": "LNY",
        "lon": "-156.95049",
        "iso": "US",
        "status": 1,
        "name": "Lanai Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.790085",
        "size": "medium"
    },
    {
        "iata": "LNS",
        "lon": "-76.29972",
        "iso": "US",
        "status": 1,
        "name": "Lancaster Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.121113",
        "size": "medium"
    },
    {
        "iata": "YLH",
        "lon": "-87.93",
        "iso": "CA",
        "status": 1,
        "name": "Lansdowne House Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.183334",
        "size": "medium"
    },
    {
        "iata": "LAR",
        "lon": "-105.67306",
        "iso": "US",
        "status": 1,
        "name": "Laramie Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.31361",
        "size": "medium"
    },
    {
        "iata": "LRD",
        "lon": "-99.455124",
        "iso": "US",
        "status": 1,
        "name": "Laredo International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "27.543667",
        "size": "medium"
    },
    {
        "iata": "LRU",
        "lon": "-106.92167",
        "iso": "US",
        "status": 1,
        "name": "Las Cruces International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.290833",
        "size": "medium"
    },
    {
        "iata": "BED",
        "lon": "-71.29",
        "iso": "US",
        "status": 1,
        "name": "Laurence G Hanscom Field",
        "continent": "NA",
        "type": "airport",
        "lat": "42.470833",
        "size": "medium"
    },
    {
        "iata": "YLR",
        "lon": "-100.03333",
        "iso": "CA",
        "status": 1,
        "name": "Leaf Rapids Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.5",
        "size": "medium"
    },
    {
        "iata": "LEB",
        "lon": "-72.310005",
        "iso": "US",
        "status": 1,
        "name": "Lebanon Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.62936",
        "size": "medium"
    },
    {
        "iata": "NBW",
        "lon": "-75.23333",
        "iso": "CU",
        "status": 1,
        "name": "Leeward Point Field",
        "continent": "NA",
        "type": "airport",
        "lat": "20.166668",
        "size": "medium"
    },
    {
        "iata": "ABE",
        "lon": "-75.434364",
        "iso": "US",
        "status": 1,
        "name": "Lehigh Valley International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.651573",
        "size": "medium"
    },
    {
        "iata": "GBJ",
        "lon": "-61.266666",
        "iso": "GP",
        "status": 1,
        "name": "Les Bases Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "15.866667",
        "size": "medium"
    },
    {
        "iata": "CYA",
        "lon": "-73.78833",
        "iso": "HT",
        "status": 1,
        "name": "Les Cayes Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.269722",
        "size": "medium"
    },
    {
        "iata": "YYZ",
        "lon": "-79.61146",
        "iso": "CA",
        "status": 1,
        "name": "Lester B. Pearson International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.681583",
        "size": "large"
    },
    {
        "iata": "YQL",
        "lon": "-112.791664",
        "iso": "CA",
        "status": 1,
        "name": "Lethbridge County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.631943",
        "size": "medium"
    },
    {
        "iata": "LWS",
        "lon": "-117.01444",
        "iso": "US",
        "status": 1,
        "name": "Lewiston Nez Perce County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.37472",
        "size": "medium"
    },
    {
        "iata": "LWT",
        "lon": "-109.47111",
        "iso": "US",
        "status": 1,
        "name": "Lewistown Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.05111",
        "size": "medium"
    },
    {
        "iata": "LBL",
        "lon": "-100.960556",
        "iso": "US",
        "status": 1,
        "name": "Liberal Mid-America Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.044445",
        "size": "medium"
    },
    {
        "iata": "CLQ",
        "lon": "-103.65",
        "iso": "MX",
        "status": 1,
        "name": "Lic. Miguel de la Madrid Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.3",
        "size": "medium"
    },
    {
        "iata": "TLC",
        "lon": "-99.56049",
        "iso": "MX",
        "status": 1,
        "name": "Licenciado Adolfo Lopez Mateos International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.333355",
        "size": "medium"
    },
    {
        "iata": "MEX",
        "lon": "-99.07278",
        "iso": "MX",
        "status": 1,
        "name": "Licenciado Benito Juarez International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.435278",
        "size": "large"
    },
    {
        "iata": "MID",
        "lon": "-89.66375",
        "iso": "MX",
        "status": 1,
        "name": "Licenciado Manuel Crescencio Rejon Int Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.933823",
        "size": "medium"
    },
    {
        "iata": "UPN",
        "lon": "-102.04722",
        "iso": "MX",
        "status": 1,
        "name": "Licenciado y General Ignacio Lopez Rayon Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.411112",
        "size": "medium"
    },
    {
        "iata": "LIH",
        "lon": "-159.34944",
        "iso": "US",
        "status": 1,
        "name": "Lihue Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.978205",
        "size": "medium"
    },
    {
        "iata": "LIO",
        "lon": "-83.02111",
        "iso": "CR",
        "status": 1,
        "name": "Limon International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "9.955833",
        "size": "medium"
    },
    {
        "iata": "LNK",
        "lon": "-96.75471",
        "iso": "US",
        "status": 1,
        "name": "Lincoln Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.846176",
        "size": "medium"
    },
    {
        "iata": "ZGR",
        "lon": "-95.46667",
        "iso": "CA",
        "status": 1,
        "name": "Little Grand Rapids Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.066666",
        "size": "medium"
    },
    {
        "iata": "YLL",
        "lon": "-110.072716",
        "iso": "CA",
        "status": 1,
        "name": "Lloydminster Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.31297",
        "size": "medium"
    },
    {
        "iata": "YXU",
        "lon": "-81.14965",
        "iso": "CA",
        "status": 1,
        "name": "London Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.02802",
        "size": "large"
    },
    {
        "iata": "LGB",
        "lon": "-118.14449",
        "iso": "US",
        "status": 1,
        "name": "Long Beach /Daugherty Field/ Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.818195",
        "size": "medium"
    },
    {
        "iata": "ISP",
        "lon": "-73.09755",
        "iso": "US",
        "status": 1,
        "name": "Long Island Mac Arthur Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.789314",
        "size": "medium"
    },
    {
        "iata": "LTO",
        "lon": "-111.35",
        "iso": "MX",
        "status": 1,
        "name": "Loreto International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.983334",
        "size": "medium"
    },
    {
        "iata": "LAX",
        "lon": "-118.40828",
        "iso": "US",
        "status": 1,
        "name": "Los Angeles International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.943398",
        "size": "large"
    },
    {
        "iata": "SJD",
        "lon": "-109.717285",
        "iso": "MX",
        "status": 1,
        "name": "Los Cabos International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "23.162354",
        "size": "large"
    },
    {
        "iata": "LSL",
        "lon": "-84.7",
        "iso": "CR",
        "status": 1,
        "name": "Los Chiles Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "11.033333",
        "size": "medium"
    },
    {
        "iata": "MSY",
        "lon": "-90.25639",
        "iso": "US",
        "status": 1,
        "name": "Louis Armstrong New Orleans International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "29.984564",
        "size": "large"
    },
    {
        "iata": "SDF",
        "lon": "-85.74179",
        "iso": "US",
        "status": 1,
        "name": "Louisville International Standiford Field",
        "continent": "NA",
        "type": "airport",
        "lat": "38.186375",
        "size": "large"
    },
    {
        "iata": "YBX",
        "lon": "-57.216667",
        "iso": "CA",
        "status": 1,
        "name": "Lourdes de Blanc Sablon Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.433334",
        "size": "medium"
    },
    {
        "iata": "CHA",
        "lon": "-85.197784",
        "iso": "US",
        "status": 1,
        "name": "Lovell Field",
        "continent": "NA",
        "type": "airport",
        "lat": "35.036926",
        "size": "large"
    },
    {
        "iata": "LBB",
        "lon": "-101.8223",
        "iso": "US",
        "status": 1,
        "name": "Lubbock Preston Smith International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.65622",
        "size": "large"
    },
    {
        "iata": "SJU",
        "lon": "-66.004684",
        "iso": "PR",
        "status": 1,
        "name": "Luis Munoz Marin International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.437403",
        "size": "large"
    },
    {
        "iata": "YSG",
        "lon": "-110.075554",
        "iso": "CA",
        "status": 1,
        "name": "Lutselk'e Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.41861",
        "size": "medium"
    },
    {
        "iata": "LYH",
        "lon": "-79.20111",
        "iso": "US",
        "status": 1,
        "name": "Lynchburg Regional Preston Glenn Field",
        "continent": "NA",
        "type": "airport",
        "lat": "37.326942",
        "size": "medium"
    },
    {
        "iata": "NAS",
        "lon": "-77.463776",
        "iso": "BS",
        "status": 1,
        "name": "Lynden Pindling International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.048223",
        "size": "large"
    },
    {
        "iata": "YYL",
        "lon": "-101.066666",
        "iso": "CA",
        "status": 1,
        "name": "Lynn Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.86667",
        "size": "medium"
    },
    {
        "iata": "YZY",
        "lon": "100.660835",
        "iso": "CA",
        "status": 1,
        "name": "Mackenzie Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.8075",
        "size": "medium"
    },
    {
        "iata": "EUG",
        "lon": "-123.21197",
        "iso": "US",
        "status": 1,
        "name": "Mahlon Sweet Field",
        "continent": "NA",
        "type": "airport",
        "lat": "44.119198",
        "size": "medium"
    },
    {
        "iata": "YMN",
        "lon": "-59.166668",
        "iso": "CA",
        "status": 1,
        "name": "Makkovik Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.166668",
        "size": "medium"
    },
    {
        "iata": "MHT",
        "lon": "-71.43844",
        "iso": "US",
        "status": 1,
        "name": "Manchester Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.92786",
        "size": "large"
    },
    {
        "iata": "MHK",
        "lon": "-96.66889",
        "iso": "US",
        "status": 1,
        "name": "Manhattan Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.142223",
        "size": "medium"
    },
    {
        "iata": "YEM",
        "lon": "-81.858055",
        "iso": "CA",
        "status": 1,
        "name": "Manitoulin East Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.842777",
        "size": "medium"
    },
    {
        "iata": "YMG",
        "lon": "-85.86667",
        "iso": "CA",
        "status": 1,
        "name": "Manitouwadge Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.083332",
        "size": "medium"
    },
    {
        "iata": "YSP",
        "lon": "-86.35",
        "iso": "CA",
        "status": 1,
        "name": "Marathon Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.75",
        "size": "medium"
    },
    {
        "iata": "PAC",
        "lon": "-79.55561",
        "iso": "PA",
        "status": 1,
        "name": "Marcos A. Gelabert International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "8.971004",
        "size": "medium"
    },
    {
        "iata": "BRX",
        "lon": "-71.11667",
        "iso": "DO",
        "status": 1,
        "name": "Maria Montez International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.216667",
        "size": "medium"
    },
    {
        "iata": "GAO",
        "lon": "-75.15861",
        "iso": "CU",
        "status": 1,
        "name": "Mariana Grajales Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.084723",
        "size": "medium"
    },
    {
        "iata": "MHH",
        "lon": "-77.07712",
        "iso": "BS",
        "status": 1,
        "name": "Marsh Harbour International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "26.513428",
        "size": "medium"
    },
    {
        "iata": "FRI",
        "lon": "-96.78333",
        "iso": "US",
        "status": 1,
        "name": "Marshall Army Air Field",
        "continent": "NA",
        "type": "airport",
        "lat": "39.083332",
        "size": "medium"
    },
    {
        "iata": "YMH",
        "lon": "-55.833332",
        "iso": "CA",
        "status": 1,
        "name": "Mary's Harbour Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.3",
        "size": "medium"
    },
    {
        "iata": "MSS",
        "lon": "-74.846664",
        "iso": "US",
        "status": 1,
        "name": "Massena International Richards Field",
        "continent": "NA",
        "type": "airport",
        "lat": "44.93778",
        "size": "medium"
    },
    {
        "iata": "ZMT",
        "lon": "-132.15",
        "iso": "CA",
        "status": 1,
        "name": "Masset Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.016666",
        "size": "medium"
    },
    {
        "iata": "YNM",
        "lon": "-77.8",
        "iso": "CA",
        "status": 1,
        "name": "Matagami Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.75",
        "size": "medium"
    },
    {
        "iata": "YME",
        "lon": "-67.51667",
        "iso": "CA",
        "status": 1,
        "name": "Matane Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.833332",
        "size": "medium"
    },
    {
        "iata": "AVI",
        "lon": "-78.79139",
        "iso": "CU",
        "status": 1,
        "name": "Maximo Gomez Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "22.025",
        "size": "medium"
    },
    {
        "iata": "MYG",
        "lon": "-73.01833",
        "iso": "BS",
        "status": 1,
        "name": "Mayaguana Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "22.376667",
        "size": "medium"
    },
    {
        "iata": "YMA",
        "lon": "-135.87361",
        "iso": "CA",
        "status": 1,
        "name": "Mayo Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "63.61639",
        "size": "medium"
    },
    {
        "iata": "MBS",
        "lon": "-84.090744",
        "iso": "US",
        "status": 1,
        "name": "MBS International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.53339",
        "size": "large"
    },
    {
        "iata": "MFE",
        "lon": "-98.23978",
        "iso": "US",
        "status": 1,
        "name": "Mc Allen Miller International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "26.181295",
        "size": "medium"
    },
    {
        "iata": "IAB",
        "lon": "-97.27617",
        "iso": "US",
        "status": 1,
        "name": "Mc Connell Air Force Base",
        "continent": "NA",
        "type": "airport",
        "lat": "37.68114",
        "size": "medium"
    },
    {
        "iata": "WRI",
        "lon": "-74.65017",
        "iso": "US",
        "status": 1,
        "name": "Mc Guire Air Force Base",
        "continent": "NA",
        "type": "airport",
        "lat": "40.155308",
        "size": "medium"
    },
    {
        "iata": "MKL",
        "lon": "-88.915276",
        "iso": "US",
        "status": 1,
        "name": "Mc Kellar Sipes Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.60139",
        "size": "medium"
    },
    {
        "iata": "LAS",
        "lon": "-115.1486",
        "iso": "US",
        "status": 1,
        "name": "McCarran International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "36.086945",
        "size": "large"
    },
    {
        "iata": "TYS",
        "lon": "-83.98973",
        "iso": "US",
        "status": 1,
        "name": "McGhee Tyson Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.80565",
        "size": "large"
    },
    {
        "iata": "MCG",
        "lon": "-155.65764",
        "iso": "US",
        "status": 1,
        "name": "McGrath Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.97875",
        "size": "medium"
    },
    {
        "iata": "YLJ",
        "lon": "-108.666664",
        "iso": "CA",
        "status": 1,
        "name": "Meadow Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.5",
        "size": "medium"
    },
    {
        "iata": "BFL",
        "lon": "-119.04533",
        "iso": "US",
        "status": 1,
        "name": "Meadows Field",
        "continent": "NA",
        "type": "airport",
        "lat": "35.429626",
        "size": "medium"
    },
    {
        "iata": "YXH",
        "lon": "-110.72083",
        "iso": "CA",
        "status": 1,
        "name": "Medicine Hat Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.015835",
        "size": "medium"
    },
    {
        "iata": "MYU",
        "lon": "-166.26805",
        "iso": "US",
        "status": 1,
        "name": "Mekoryuk Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.37278",
        "size": "medium"
    },
    {
        "iata": "MLB",
        "lon": "-80.63028",
        "iso": "US",
        "status": 1,
        "name": "Melbourne International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "28.1025",
        "size": "medium"
    },
    {
        "iata": "DOM",
        "lon": "-61.309166",
        "iso": "DM",
        "status": 1,
        "name": "Melville Hall Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "15.543056",
        "size": "medium"
    },
    {
        "iata": "HOT",
        "lon": "-93.09611",
        "iso": "US",
        "status": 1,
        "name": "Memorial Field",
        "continent": "NA",
        "type": "airport",
        "lat": "34.47889",
        "size": "medium"
    },
    {
        "iata": "MEM",
        "lon": "-89.98226",
        "iso": "US",
        "status": 1,
        "name": "Memphis International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.04458",
        "size": "large"
    },
    {
        "iata": "MCE",
        "lon": "-120.51278",
        "iso": "US",
        "status": 1,
        "name": "Merced Regional Macready Field",
        "continent": "NA",
        "type": "airport",
        "lat": "37.28472",
        "size": "medium"
    },
    {
        "iata": "PSE",
        "lon": "-66.563545",
        "iso": "PR",
        "status": 1,
        "name": "Mercedita Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.010702",
        "size": "medium"
    },
    {
        "iata": "BLF",
        "lon": "-81.20805",
        "iso": "US",
        "status": 1,
        "name": "Mercer County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.295834",
        "size": "medium"
    },
    {
        "iata": "CDV",
        "lon": "-145.47",
        "iso": "US",
        "status": 1,
        "name": "Merle K (Mudhole) Smith Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.493057",
        "size": "medium"
    },
    {
        "iata": "MRI",
        "lon": "-149.9",
        "iso": "US",
        "status": 1,
        "name": "Merrill Field",
        "continent": "NA",
        "type": "airport",
        "lat": "61.233334",
        "size": "medium"
    },
    {
        "iata": "OAK",
        "lon": "-122.21201",
        "iso": "US",
        "status": 1,
        "name": "Metropolitan Oakland International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.71188",
        "size": "large"
    },
    {
        "iata": "MIA",
        "lon": "-80.27824",
        "iso": "US",
        "status": 1,
        "name": "Miami International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.796",
        "size": "large"
    },
    {
        "iata": "GLH",
        "lon": "-90.985",
        "iso": "US",
        "status": 1,
        "name": "Mid Delta Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.484444",
        "size": "medium"
    },
    {
        "iata": "PKB",
        "lon": "-81.43889",
        "iso": "US",
        "status": 1,
        "name": "Mid Ohio Valley Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.345554",
        "size": "medium"
    },
    {
        "iata": "MCN",
        "lon": "-83.64865",
        "iso": "US",
        "status": 1,
        "name": "Middle Georgia Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.70199",
        "size": "medium"
    },
    {
        "iata": "MAF",
        "lon": "-102.20817",
        "iso": "US",
        "status": 1,
        "name": "Midland International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "31.937145",
        "size": "medium"
    },
    {
        "iata": "MSP",
        "lon": "-93.21092",
        "iso": "US",
        "status": 1,
        "name": "Minneapolis-St Paul International/Wold-Chamberlain Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.883015",
        "size": "large"
    },
    {
        "iata": "MOT",
        "lon": "-101.28083",
        "iso": "US",
        "status": 1,
        "name": "Minot International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.259724",
        "size": "medium"
    },
    {
        "iata": "MQC",
        "lon": "-56.333332",
        "iso": "PM",
        "status": 1,
        "name": "Miquelon Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.05",
        "size": "medium"
    },
    {
        "iata": "YCH",
        "lon": "-65.44744",
        "iso": "CA",
        "status": 1,
        "name": "Miramichi Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.014008",
        "size": "medium"
    },
    {
        "iata": "MSO",
        "lon": "-114.08321",
        "iso": "US",
        "status": 1,
        "name": "Missoula International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.918964",
        "size": "medium"
    },
    {
        "iata": "MOB",
        "lon": "-88.24475",
        "iso": "US",
        "status": 1,
        "name": "Mobile Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "30.681086",
        "size": "large"
    },
    {
        "iata": "MOD",
        "lon": "-120.95528",
        "iso": "US",
        "status": 1,
        "name": "Modesto City Co-Harry Sham Field",
        "continent": "NA",
        "type": "airport",
        "lat": "37.626945",
        "size": "medium"
    },
    {
        "iata": "MKK",
        "lon": "-157.1",
        "iso": "US",
        "status": 1,
        "name": "Molokai Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.152779",
        "size": "medium"
    },
    {
        "iata": "LOV",
        "lon": "-101.416664",
        "iso": "MX",
        "status": 1,
        "name": "Monclova International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "26.9",
        "size": "medium"
    },
    {
        "iata": "BMG",
        "lon": "-86.61472",
        "iso": "US",
        "status": 1,
        "name": "Monroe County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.14",
        "size": "medium"
    },
    {
        "iata": "MLU",
        "lon": "-92.043655",
        "iso": "US",
        "status": 1,
        "name": "Monroe Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.51184",
        "size": "large"
    },
    {
        "iata": "YYY",
        "lon": "-68.2",
        "iso": "CA",
        "status": 1,
        "name": "Mont Joli Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.6",
        "size": "medium"
    },
    {
        "iata": "MRY",
        "lon": "-121.850815",
        "iso": "US",
        "status": 1,
        "name": "Monterey Peninsula Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "36.587296",
        "size": "medium"
    },
    {
        "iata": "MGM",
        "lon": "-86.39029",
        "iso": "US",
        "status": 1,
        "name": "Montgomery Regional (Dannelly Field) Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.305042",
        "size": "large"
    },
    {
        "iata": "YUL",
        "lon": "-73.74991",
        "iso": "CA",
        "status": 1,
        "name": "Montreal / Pierre Elliott Trudeau International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.457714",
        "size": "large"
    },
    {
        "iata": "YMX",
        "lon": "-74.03",
        "iso": "CA",
        "status": 1,
        "name": "Montreal International (Mirabel) Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.666668",
        "size": "medium"
    },
    {
        "iata": "YMJ",
        "lon": "-105.53333",
        "iso": "CA",
        "status": 1,
        "name": "Moose Jaw Air Vice Marshal C. M. McEwen Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.38333",
        "size": "medium"
    },
    {
        "iata": "YMO",
        "lon": "-80.604164",
        "iso": "CA",
        "status": 1,
        "name": "Moosonee Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.29111",
        "size": "medium"
    },
    {
        "iata": "MGW",
        "lon": "-79.91583",
        "iso": "US",
        "status": 1,
        "name": "Morgantown Municipal Walter L. Bill Hart Field",
        "continent": "NA",
        "type": "airport",
        "lat": "39.642776",
        "size": "medium"
    },
    {
        "iata": "MMU",
        "lon": "-74.41583",
        "iso": "US",
        "status": 1,
        "name": "Morristown Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.799168",
        "size": "medium"
    },
    {
        "iata": "FRS",
        "lon": "-89.88333",
        "iso": "GT",
        "status": 1,
        "name": "Mundo Maya International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "16.916668",
        "size": "medium"
    },
    {
        "iata": "YQA",
        "lon": "-79.3",
        "iso": "CA",
        "status": 1,
        "name": "Muskoka Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.966667",
        "size": "medium"
    },
    {
        "iata": "MSA",
        "lon": "-91.98333",
        "iso": "CA",
        "status": 1,
        "name": "Muskrat Dam Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.816666",
        "size": "medium"
    },
    {
        "iata": "MQS",
        "lon": "-61.181946",
        "iso": "VC",
        "status": 1,
        "name": "Mustique Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "12.888333",
        "size": "medium"
    },
    {
        "iata": "MYR",
        "lon": "-78.92294",
        "iso": "US",
        "status": 1,
        "name": "Myrtle Beach International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.682674",
        "size": "large"
    },
    {
        "iata": "YDP",
        "lon": "-61.666668",
        "iso": "CA",
        "status": 1,
        "name": "Nain Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.533333",
        "size": "medium"
    },
    {
        "iata": "YQN",
        "lon": "-86.7",
        "iso": "CA",
        "status": 1,
        "name": "Nakina Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.166668",
        "size": "medium"
    },
    {
        "iata": "YCD",
        "lon": "-123.86667",
        "iso": "CA",
        "status": 1,
        "name": "Nanaimo Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.05",
        "size": "medium"
    },
    {
        "iata": "ACK",
        "lon": "-70.05972",
        "iso": "US",
        "status": 1,
        "name": "Nantucket Memorial Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.256668",
        "size": "medium"
    },
    {
        "iata": "APF",
        "lon": "-81.775276",
        "iso": "US",
        "status": 1,
        "name": "Naples Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "26.152779",
        "size": "medium"
    },
    {
        "iata": "UAK",
        "lon": "-45.316666",
        "iso": "GL",
        "status": 1,
        "name": "Narsarsuaq Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "61.166668",
        "size": "medium"
    },
    {
        "iata": "BNA",
        "lon": "-86.668945",
        "iso": "US",
        "status": 1,
        "name": "Nashville International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "36.13174",
        "size": "large"
    },
    {
        "iata": "YNA",
        "lon": "-61.8",
        "iso": "CA",
        "status": 1,
        "name": "Natashquan Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.183334",
        "size": "medium"
    },
    {
        "iata": "YNN",
        "lon": "119.23333",
        "iso": "CA",
        "status": 1,
        "name": "Nejanilini Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "-22.766666",
        "size": "medium"
    },
    {
        "iata": "YNS",
        "lon": "-76.74167",
        "iso": "CA",
        "status": 1,
        "name": "Nemiscau Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.74167",
        "size": "medium"
    },
    {
        "iata": "ENN",
        "lon": "-149.11667",
        "iso": "US",
        "status": 1,
        "name": "Nenana Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.566666",
        "size": "medium"
    },
    {
        "iata": "EWB",
        "lon": "-70.95917",
        "iso": "US",
        "status": 1,
        "name": "New Bedford Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.676945",
        "size": "medium"
    },
    {
        "iata": "CAT",
        "lon": "-75.45361",
        "iso": "BS",
        "status": 1,
        "name": "New Bight Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "24.315",
        "size": "medium"
    },
    {
        "iata": "ILG",
        "lon": "-75.6075",
        "iso": "US",
        "status": 1,
        "name": "New Castle Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.678333",
        "size": "medium"
    },
    {
        "iata": "EWR",
        "lon": "-74.17876",
        "iso": "US",
        "status": 1,
        "name": "Newark Liberty International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.68907",
        "size": "large"
    },
    {
        "iata": "PHF",
        "lon": "-76.50282",
        "iso": "US",
        "status": 1,
        "name": "Newport News Williamsburg International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.13033",
        "size": "large"
    },
    {
        "iata": "YCM",
        "lon": "-79.166664",
        "iso": "CA",
        "status": 1,
        "name": "Niagara District Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.2",
        "size": "medium"
    },
    {
        "iata": "IAG",
        "lon": "-78.95",
        "iso": "US",
        "status": 1,
        "name": "Niagara Falls International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.1",
        "size": "medium"
    },
    {
        "iata": "WTK",
        "lon": "-162.98416",
        "iso": "US",
        "status": 1,
        "name": "Noatak Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "67.56306",
        "size": "medium"
    },
    {
        "iata": "OME",
        "lon": "-165.44167",
        "iso": "US",
        "status": 1,
        "name": "Nome Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.51139",
        "size": "medium"
    },
    {
        "iata": "ORF",
        "lon": "-76.20629",
        "iso": "US",
        "status": 1,
        "name": "Norfolk International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "36.898582",
        "size": "large"
    },
    {
        "iata": "KIN",
        "lon": "-76.77816",
        "iso": "JM",
        "status": 1,
        "name": "Norman Manley International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.93775",
        "size": "large"
    },
    {
        "iata": "YVQ",
        "lon": "-126.79337",
        "iso": "CA",
        "status": 1,
        "name": "Norman Wells Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "65.277855",
        "size": "medium"
    },
    {
        "iata": "SJC",
        "lon": "-121.92638",
        "iso": "US",
        "status": 1,
        "name": "Norman Y. Mineta San Jose International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.366737",
        "size": "large"
    },
    {
        "iata": "NMC",
        "lon": "-76.82",
        "iso": "BS",
        "status": 1,
        "name": "Normans Cay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "24.59361",
        "size": "medium"
    },
    {
        "iata": "YQW",
        "lon": "-108.25",
        "iso": "CA",
        "status": 1,
        "name": "North Battleford Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.766666",
        "size": "medium"
    },
    {
        "iata": "YYB",
        "lon": "-79.42725",
        "iso": "CA",
        "status": 1,
        "name": "North Bay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.356823",
        "size": "medium"
    },
    {
        "iata": "NCA",
        "lon": "-71.98333",
        "iso": "TC",
        "status": 1,
        "name": "North Caicos Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.933332",
        "size": "medium"
    },
    {
        "iata": "CKB",
        "lon": "-80.22945",
        "iso": "US",
        "status": 1,
        "name": "North Central West Virginia Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.295555",
        "size": "medium"
    },
    {
        "iata": "ELH",
        "lon": "-76.68192",
        "iso": "BS",
        "status": 1,
        "name": "North Eleuthera Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.476917",
        "size": "medium"
    },
    {
        "iata": "LBF",
        "lon": "-100.69667",
        "iso": "US",
        "status": 1,
        "name": "North Platte Regional Airport Lee Bird Field",
        "continent": "NA",
        "type": "airport",
        "lat": "41.128334",
        "size": "medium"
    },
    {
        "iata": "PQI",
        "lon": "-68.0475",
        "iso": "US",
        "status": 1,
        "name": "Northern Maine Regional Airport at Presque Isle",
        "continent": "NA",
        "type": "airport",
        "lat": "46.685",
        "size": "medium"
    },
    {
        "iata": "ORT",
        "lon": "-141.92389",
        "iso": "US",
        "status": 1,
        "name": "Northway Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.961945",
        "size": "medium"
    },
    {
        "iata": "MSL",
        "lon": "-87.61611",
        "iso": "US",
        "status": 1,
        "name": "Northwest Alabama Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "34.74861",
        "size": "medium"
    },
    {
        "iata": "YNE",
        "lon": "-97.84583",
        "iso": "CA",
        "status": 1,
        "name": "Norway House Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.954166",
        "size": "medium"
    },
    {
        "iata": "NOM",
        "lon": "142.21666",
        "iso": "CR",
        "status": 1,
        "name": "Nosara Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "-6.3",
        "size": "medium"
    },
    {
        "iata": "NUI",
        "lon": "-151.00555",
        "iso": "US",
        "status": 1,
        "name": "Nuiqsut Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "70.209724",
        "size": "medium"
    },
    {
        "iata": "YOC",
        "lon": "-139.83333",
        "iso": "CA",
        "status": 1,
        "name": "Old Crow Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "67.583336",
        "size": "medium"
    },
    {
        "iata": "OLM",
        "lon": "-122.903336",
        "iso": "US",
        "status": 1,
        "name": "Olympia Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.97361",
        "size": "medium"
    },
    {
        "iata": "ONT",
        "lon": "-117.59765",
        "iso": "US",
        "status": 1,
        "name": "Ontario International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "34.06068",
        "size": "large"
    },
    {
        "iata": "MOA",
        "lon": "-74.88333",
        "iso": "CU",
        "status": 1,
        "name": "Orestes Acosta Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.5",
        "size": "medium"
    },
    {
        "iata": "MCO",
        "lon": "-81.308304",
        "iso": "US",
        "status": 1,
        "name": "Orlando International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "28.432177",
        "size": "large"
    },
    {
        "iata": "SFB",
        "lon": "-81.2432",
        "iso": "US",
        "status": 1,
        "name": "Orlando Sanford International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "28.775118",
        "size": "large"
    },
    {
        "iata": "YOO",
        "lon": "-78.9",
        "iso": "CA",
        "status": 1,
        "name": "Oshawa Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.916668",
        "size": "medium"
    },
    {
        "iata": "YRP",
        "iso": "CA",
        "status": 1,
        "name": "Ottawa / Carp Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "YND",
        "lon": "-75.56283",
        "iso": "CA",
        "status": 1,
        "name": "Ottawa / Gatineau Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.52063",
        "size": "medium"
    },
    {
        "iata": "YRO",
        "lon": "-75.76459",
        "iso": "CA",
        "status": 1,
        "name": "Ottawa / Rockcliffe Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.4592",
        "size": "medium"
    },
    {
        "iata": "YOW",
        "lon": "-75.672775",
        "iso": "CA",
        "status": 1,
        "name": "Ottawa Macdonald-Cartier International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.32083",
        "size": "large"
    },
    {
        "iata": "OTM",
        "lon": "-92.449165",
        "iso": "US",
        "status": 1,
        "name": "Ottumwa Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.106388",
        "size": "medium"
    },
    {
        "iata": "GCM",
        "lon": "-81.35779",
        "iso": "KY",
        "status": 1,
        "name": "Owen Roberts International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.29637",
        "size": "large"
    },
    {
        "iata": "YOS",
        "lon": "-80.8375",
        "iso": "CA",
        "status": 1,
        "name": "Owen Sound / Billy Bishop Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.59028",
        "size": "medium"
    },
    {
        "iata": "OWB",
        "lon": "-87.16583",
        "iso": "US",
        "status": 1,
        "name": "Owensboro Daviess County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.740833",
        "size": "medium"
    },
    {
        "iata": "YOH",
        "lon": "-95.27668",
        "iso": "CA",
        "status": 1,
        "name": "Oxford House Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.934242",
        "size": "medium"
    },
    {
        "iata": "PBI",
        "lon": "-80.09044",
        "iso": "US",
        "status": 1,
        "name": "Palm Beach International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "26.688885",
        "size": "large"
    },
    {
        "iata": "PSP",
        "lon": "-116.508446",
        "iso": "US",
        "status": 1,
        "name": "Palm Springs International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.822975",
        "size": "medium"
    },
    {
        "iata": "PMZ",
        "lon": "-83.46598",
        "iso": "CR",
        "status": 1,
        "name": "Palmar Sur Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "8.950836",
        "size": "medium"
    },
    {
        "iata": "PMD",
        "lon": "-118.083336",
        "iso": "US",
        "status": 1,
        "name": "Palmdale Regional/USAF Plant 42 Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "34.6275",
        "size": "medium"
    },
    {
        "iata": "PAQ",
        "lon": "-149.11667",
        "iso": "US",
        "status": 1,
        "name": "Palmer Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "61.6",
        "size": "medium"
    },
    {
        "iata": "PFN",
        "lon": "-85.68309",
        "iso": "US",
        "status": 1,
        "name": "Panama City-Bay Co International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "30.207085",
        "size": "medium"
    },
    {
        "iata": "YXP",
        "lon": "-65.73333",
        "iso": "CA",
        "status": 1,
        "name": "Pangnirtung Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "66.13333",
        "size": "medium"
    },
    {
        "iata": "YPC",
        "lon": "-124.07468",
        "iso": "CA",
        "status": 1,
        "name": "Paulatuk (Nora Aliqatchialuk Ruben) Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "69.35514",
        "size": "medium"
    },
    {
        "iata": "YPE",
        "lon": "-117.44028",
        "iso": "CA",
        "status": 1,
        "name": "Peace River Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.22778",
        "size": "medium"
    },
    {
        "iata": "YPO",
        "lon": "-85.433334",
        "iso": "CA",
        "status": 1,
        "name": "Peawanuck Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.983334",
        "size": "medium"
    },
    {
        "iata": "PLN",
        "lon": "-84.79278",
        "iso": "US",
        "status": 1,
        "name": "Pellston Regional Airport of Emmet County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.57083",
        "size": "medium"
    },
    {
        "iata": "YTA",
        "lon": "-77.24944",
        "iso": "CA",
        "status": 1,
        "name": "Pembroke Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.861668",
        "size": "medium"
    },
    {
        "iata": "PNS",
        "lon": "-87.19416",
        "iso": "US",
        "status": 1,
        "name": "Pensacola Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "30.475943",
        "size": "medium"
    },
    {
        "iata": "YYF",
        "lon": "-119.6",
        "iso": "CA",
        "status": 1,
        "name": "Penticton Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.46472",
        "size": "medium"
    },
    {
        "iata": "YWA",
        "lon": "-77.28333",
        "iso": "CA",
        "status": 1,
        "name": "Petawawa Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.9",
        "size": "medium"
    },
    {
        "iata": "YPQ",
        "lon": "-78.316666",
        "iso": "CA",
        "status": 1,
        "name": "Peterborough Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.3",
        "size": "medium"
    },
    {
        "iata": "PSG",
        "lon": "-132.9425",
        "iso": "US",
        "status": 1,
        "name": "Petersburg James A Johnson Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.80417",
        "size": "medium"
    },
    {
        "iata": "PHL",
        "lon": "-75.2433",
        "iso": "US",
        "status": 1,
        "name": "Philadelphia International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.87641",
        "size": "large"
    },
    {
        "iata": "BZE",
        "lon": "-88.308334",
        "iso": "BZ",
        "status": 1,
        "name": "Philip S. W. Goldson International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.539167",
        "size": "large"
    },
    {
        "iata": "APG",
        "lon": "-76.166664",
        "iso": "US",
        "status": 1,
        "name": "Phillips Army Air Field",
        "continent": "NA",
        "type": "airport",
        "lat": "39.5",
        "size": "medium"
    },
    {
        "iata": "PHX",
        "lon": "-112.00016",
        "iso": "US",
        "status": 1,
        "name": "Phoenix Sky Harbor International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.435036",
        "size": "large"
    },
    {
        "iata": "AZA",
        "lon": "-111.655556",
        "iso": "US",
        "status": 1,
        "name": "Phoenix-Mesa-Gateway Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.307777",
        "size": "medium"
    },
    {
        "iata": "POS",
        "lon": "-61.339413",
        "iso": "TT",
        "status": 1,
        "name": "Piarco International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "10.602089",
        "size": "medium"
    },
    {
        "iata": "YPL",
        "lon": "-90.208336",
        "iso": "CA",
        "status": 1,
        "name": "Pickle Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.208332",
        "size": "medium"
    },
    {
        "iata": "GSO",
        "lon": "-79.9373",
        "iso": "US",
        "status": 1,
        "name": "Piedmont Triad International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "36.105324",
        "size": "large"
    },
    {
        "iata": "PDS",
        "lon": "-100.53604",
        "iso": "MX",
        "status": 1,
        "name": "Piedras Negras International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "28.628948",
        "size": "medium"
    },
    {
        "iata": "PIR",
        "lon": "-100.29319",
        "iso": "US",
        "status": 1,
        "name": "Pierre Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.380363",
        "size": "medium"
    },
    {
        "iata": "YPM",
        "lon": "-93.97287",
        "iso": "CA",
        "status": 1,
        "name": "Pikangikum Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.817375",
        "size": "medium"
    },
    {
        "iata": "PIW",
        "lon": "-97.333336",
        "iso": "CA",
        "status": 1,
        "name": "Pikwitonei Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.7",
        "size": "medium"
    },
    {
        "iata": "QPD",
        "iso": "CU",
        "status": 1,
        "name": "Pinar Del Rio Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "PIT",
        "lon": "-80.25657",
        "iso": "US",
        "status": 1,
        "name": "Pittsburgh International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.49585",
        "size": "large"
    },
    {
        "iata": "PLJ",
        "lon": "-88.360886",
        "iso": "BZ",
        "status": 1,
        "name": "Placencia Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "16.53708",
        "size": "medium"
    },
    {
        "iata": "SLW",
        "lon": "-100.916664",
        "iso": "MX",
        "status": 1,
        "name": "Plan De Guadalupe International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.55",
        "size": "medium"
    },
    {
        "iata": "PTU",
        "lon": "-161.81694",
        "iso": "US",
        "status": 1,
        "name": "Platinum Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "59.01139",
        "size": "medium"
    },
    {
        "iata": "PBG",
        "lon": "-73.48333",
        "iso": "US",
        "status": 1,
        "name": "Plattsburgh International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.7",
        "size": "medium"
    },
    {
        "iata": "UPB",
        "lon": "-82.579445",
        "iso": "CU",
        "status": 1,
        "name": "Playa Baracoa Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "23.032778",
        "size": "medium"
    },
    {
        "iata": "ZLO",
        "lon": "-104.350555",
        "iso": "MX",
        "status": 1,
        "name": "Playa De Oro International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.113333",
        "size": "medium"
    },
    {
        "iata": "PIH",
        "lon": "-112.594444",
        "iso": "US",
        "status": 1,
        "name": "Pocatello Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.913334",
        "size": "medium"
    },
    {
        "iata": "PIZ",
        "lon": "-163.16667",
        "iso": "US",
        "status": 1,
        "name": "Point Lay Lrrs Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "69.75",
        "size": "medium"
    },
    {
        "iata": "GND",
        "lon": "-61.78611",
        "iso": "GD",
        "status": 1,
        "name": "Point Salines International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "12.004167",
        "size": "medium"
    },
    {
        "iata": "YNL",
        "lon": "-104.08111",
        "iso": "CA",
        "status": 1,
        "name": "Points North Landing Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.275",
        "size": "medium"
    },
    {
        "iata": "SLP",
        "lon": "-100.936806",
        "iso": "MX",
        "status": 1,
        "name": "Ponciano Arriaga International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "22.255466",
        "size": "medium"
    },
    {
        "iata": "YIO",
        "lon": "-78.0",
        "iso": "CA",
        "status": 1,
        "name": "Pond Inlet Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "72.683334",
        "size": "medium"
    },
    {
        "iata": "ZNG",
        "lon": "-97.26667",
        "iso": "CA",
        "status": 1,
        "name": "Poplar River Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.0",
        "size": "medium"
    },
    {
        "iata": "KPC",
        "lon": "-166.85583",
        "iso": "US",
        "status": 1,
        "name": "Port Clarence Coast Guard Station",
        "continent": "NA",
        "type": "airport",
        "lat": "65.25444",
        "size": "medium"
    },
    {
        "iata": "CMH",
        "lon": "-82.884964",
        "iso": "US",
        "status": 1,
        "name": "Port Columbus International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.99818",
        "size": "large"
    },
    {
        "iata": "YZT",
        "lon": "-127.36389",
        "iso": "CA",
        "status": 1,
        "name": "Port Hardy Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.680557",
        "size": "medium"
    },
    {
        "iata": "YPS",
        "lon": "-61.35",
        "iso": "CA",
        "status": 1,
        "name": "Port Hawkesbury Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.61667",
        "size": "medium"
    },
    {
        "iata": "PTH",
        "lon": "-158.6375",
        "iso": "US",
        "status": 1,
        "name": "Port Heiden Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.95667",
        "size": "medium"
    },
    {
        "iata": "YPN",
        "lon": "-64.28831",
        "iso": "CA",
        "status": 1,
        "name": "Port Menier Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.836533",
        "size": "medium"
    },
    {
        "iata": "PAX",
        "lon": "-72.84167",
        "iso": "HT",
        "status": 1,
        "name": "Port-de-Paix Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "19.933332",
        "size": "medium"
    },
    {
        "iata": "PDX",
        "lon": "-122.5929",
        "iso": "US",
        "status": 1,
        "name": "Portland International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.588997",
        "size": "large"
    },
    {
        "iata": "PWM",
        "lon": "-70.31031",
        "iso": "US",
        "status": 1,
        "name": "Portland International Jetport Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.64749",
        "size": "large"
    },
    {
        "iata": "PSM",
        "lon": "-70.88272",
        "iso": "US",
        "status": 1,
        "name": "Portsmouth International at Pease Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.179585",
        "size": "medium"
    },
    {
        "iata": "YPW",
        "lon": "-124.5",
        "iso": "CA",
        "status": 1,
        "name": "Powell River Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.816666",
        "size": "medium"
    },
    {
        "iata": "YPA",
        "lon": "-105.683334",
        "iso": "CA",
        "status": 1,
        "name": "Prince Albert Glass Field",
        "continent": "NA",
        "type": "airport",
        "lat": "53.216667",
        "size": "medium"
    },
    {
        "iata": "YXS",
        "lon": "-122.67396",
        "iso": "CA",
        "status": 1,
        "name": "Prince George Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.88381",
        "size": "medium"
    },
    {
        "iata": "YPR",
        "lon": "-130.44083",
        "iso": "CA",
        "status": 1,
        "name": "Prince Rupert Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.287224",
        "size": "medium"
    },
    {
        "iata": "SXM",
        "lon": "-63.11406",
        "iso": "AN",
        "status": 1,
        "name": "Princess Juliana International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.044722",
        "size": "large"
    },
    {
        "iata": "PLS",
        "lon": "-72.26833",
        "iso": "TC",
        "status": 1,
        "name": "Providenciales Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.769167",
        "size": "medium"
    },
    {
        "iata": "PBR",
        "lon": "-88.60611",
        "iso": "GT",
        "status": 1,
        "name": "Puerto Barrios Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "15.723056",
        "size": "medium"
    },
    {
        "iata": "PUZ",
        "lon": "-83.38361",
        "iso": "NI",
        "status": 1,
        "name": "Puerto Cabezas Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "14.045278",
        "size": "medium"
    },
    {
        "iata": "PXM",
        "lon": "-97.083336",
        "iso": "MX",
        "status": 1,
        "name": "Puerto Escondido International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "15.85",
        "size": "medium"
    },
    {
        "iata": "PJM",
        "lon": "-83.333336",
        "iso": "CR",
        "status": 1,
        "name": "Puerto Jimenez Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "8.583333",
        "size": "medium"
    },
    {
        "iata": "ZFG",
        "iso": "CA",
        "status": 1,
        "name": "Pukatawagan Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "PUW",
        "lon": "-117.105",
        "iso": "US",
        "status": 1,
        "name": "Pullman Moscow Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.74472",
        "size": "medium"
    },
    {
        "iata": "PUJ",
        "lon": "-68.364",
        "iso": "DO",
        "status": 1,
        "name": "Punta Cana International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.562477",
        "size": "medium"
    },
    {
        "iata": "PND",
        "lon": "-88.816666",
        "iso": "BZ",
        "status": 1,
        "name": "Punta Gorda Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "16.1",
        "size": "medium"
    },
    {
        "iata": "LAF",
        "lon": "-86.93361",
        "iso": "US",
        "status": 1,
        "name": "Purdue University Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.411945",
        "size": "medium"
    },
    {
        "iata": "YPX",
        "lon": "-77.166664",
        "iso": "CA",
        "status": 1,
        "name": "Puvirnituq Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.033333",
        "size": "medium"
    },
    {
        "iata": "YVM",
        "lon": "-63.833332",
        "iso": "CA",
        "status": 1,
        "name": "Qikiqtarjuaq Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "67.583336",
        "size": "medium"
    },
    {
        "iata": "MLI",
        "lon": "-90.50611",
        "iso": "US",
        "status": 1,
        "name": "Quad City International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.453896",
        "size": "large"
    },
    {
        "iata": "YQC",
        "lon": "-69.63333",
        "iso": "CA",
        "status": 1,
        "name": "Quaqtaq Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "61.333332",
        "size": "medium"
    },
    {
        "iata": "YQB",
        "lon": "-71.383385",
        "iso": "CA",
        "status": 1,
        "name": "Quebec Jean Lesage International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.792038",
        "size": "large"
    },
    {
        "iata": "AUA",
        "lon": "-70.013885",
        "iso": "AW",
        "status": 1,
        "name": "Queen Beatrix International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "12.502222",
        "size": "medium"
    },
    {
        "iata": "XQP",
        "lon": "-84.13335",
        "iso": "CR",
        "status": 1,
        "name": "Quepos Managua Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "9.439146",
        "size": "medium"
    },
    {
        "iata": "YQZ",
        "lon": "-122.50972",
        "iso": "CA",
        "status": 1,
        "name": "Quesnel Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.02667",
        "size": "medium"
    },
    {
        "iata": "UIN",
        "lon": "-91.19722",
        "iso": "US",
        "status": 1,
        "name": "Quincy Regional Baldwin Field",
        "continent": "NA",
        "type": "airport",
        "lat": "39.944168",
        "size": "medium"
    },
    {
        "iata": "YRA",
        "lon": "-117.35",
        "iso": "CA",
        "status": 1,
        "name": "Rae Lakes Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.11667",
        "size": "medium"
    },
    {
        "iata": "GER",
        "lon": "-82.78",
        "iso": "CU",
        "status": 1,
        "name": "Rafael Cabrera Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.8375",
        "size": "medium"
    },
    {
        "iata": "BQN",
        "lon": "-67.13",
        "iso": "PR",
        "status": 1,
        "name": "Rafael Hernandez Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.495832",
        "size": "medium"
    },
    {
        "iata": "YOP",
        "lon": "-119.4",
        "iso": "CA",
        "status": 1,
        "name": "Rainbow Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.5",
        "size": "medium"
    },
    {
        "iata": "BKW",
        "lon": "-81.12417",
        "iso": "US",
        "status": 1,
        "name": "Raleigh County Memorial Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.781944",
        "size": "medium"
    },
    {
        "iata": "RDU",
        "lon": "-78.79086",
        "iso": "US",
        "status": 1,
        "name": "Raleigh Durham International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.873592",
        "size": "large"
    },
    {
        "iata": "OTZ",
        "lon": "-162.60583",
        "iso": "US",
        "status": 1,
        "name": "Ralph Wien Memorial Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "66.888054",
        "size": "medium"
    },
    {
        "iata": "YRT",
        "lon": "-92.10019",
        "iso": "CA",
        "status": 1,
        "name": "Rankin Inlet Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.80998",
        "size": "medium"
    },
    {
        "iata": "RAP",
        "lon": "-103.06118",
        "iso": "US",
        "status": 1,
        "name": "Rapid City Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.037582",
        "size": "medium"
    },
    {
        "iata": "RDG",
        "lon": "-75.96389",
        "iso": "US",
        "status": 1,
        "name": "Reading Regional Carl A Spaatz Field",
        "continent": "NA",
        "type": "airport",
        "lat": "40.378613",
        "size": "medium"
    },
    {
        "iata": "YQF",
        "lon": "-113.89333",
        "iso": "CA",
        "status": 1,
        "name": "Red Deer Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.176945",
        "size": "medium"
    },
    {
        "iata": "YRL",
        "lon": "-93.80006",
        "iso": "CA",
        "status": 1,
        "name": "Red Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.068764",
        "size": "medium"
    },
    {
        "iata": "YRS",
        "lon": "-93.55762",
        "iso": "CA",
        "status": 1,
        "name": "Red Sucker Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.16757",
        "size": "medium"
    },
    {
        "iata": "RDD",
        "lon": "-122.29991",
        "iso": "US",
        "status": 1,
        "name": "Redding Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.505768",
        "size": "medium"
    },
    {
        "iata": "YQR",
        "lon": "-104.65519",
        "iso": "CA",
        "status": 1,
        "name": "Regina International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.433327",
        "size": "medium"
    },
    {
        "iata": "RNO",
        "lon": "-119.775696",
        "iso": "US",
        "status": 1,
        "name": "Reno Tahoe International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "39.505783",
        "size": "large"
    },
    {
        "iata": "YUT",
        "lon": "-86.25",
        "iso": "CA",
        "status": 1,
        "name": "Repulse Bay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "66.53333",
        "size": "medium"
    },
    {
        "iata": "YRB",
        "lon": "-94.96667",
        "iso": "CA",
        "status": 1,
        "name": "Resolute Bay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "74.71667",
        "size": "medium"
    },
    {
        "iata": "RER",
        "lon": "-91.696945",
        "iso": "GT",
        "status": 1,
        "name": "Retalhuleu Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "14.520278",
        "size": "medium"
    },
    {
        "iata": "YRV",
        "lon": "-118.166664",
        "iso": "CA",
        "status": 1,
        "name": "Revelstoke Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.0",
        "size": "medium"
    },
    {
        "iata": "RHI",
        "lon": "-89.46253",
        "iso": "US",
        "status": 1,
        "name": "Rhinelander Oneida County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.625706",
        "size": "medium"
    },
    {
        "iata": "RIC",
        "lon": "-77.3225",
        "iso": "US",
        "status": 1,
        "name": "Richmond International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.50611",
        "size": "large"
    },
    {
        "iata": "AMA",
        "lon": "-101.70513",
        "iso": "US",
        "status": 1,
        "name": "Rick Husband Amarillo International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.218273",
        "size": "large"
    },
    {
        "iata": "YXK",
        "lon": "-68.55",
        "iso": "CA",
        "status": 1,
        "name": "Rimouski Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.433334",
        "size": "medium"
    },
    {
        "iata": "ROA",
        "lon": "-79.97038",
        "iso": "US",
        "status": 1,
        "name": "Roanoke Regional Woodrum Field",
        "continent": "NA",
        "type": "airport",
        "lat": "37.32051",
        "size": "large"
    },
    {
        "iata": "GRK",
        "lon": "-97.820915",
        "iso": "US",
        "status": 1,
        "name": "Robert Gray  Army Air Field Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "31.061821",
        "size": "medium"
    },
    {
        "iata": "SKB",
        "lon": "-62.71397",
        "iso": "KN",
        "status": 1,
        "name": "Robert L. Bradshaw International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.310843",
        "size": "medium"
    },
    {
        "iata": "RDM",
        "lon": "-121.162895",
        "iso": "US",
        "status": 1,
        "name": "Roberts Field",
        "continent": "NA",
        "type": "airport",
        "lat": "44.254272",
        "size": "medium"
    },
    {
        "iata": "YRJ",
        "lon": "-72.26733",
        "iso": "CA",
        "status": 1,
        "name": "Roberval Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.522343",
        "size": "medium"
    },
    {
        "iata": "RST",
        "lon": "-92.48977",
        "iso": "US",
        "status": 1,
        "name": "Rochester International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.910793",
        "size": "large"
    },
    {
        "iata": "RSD",
        "lon": "-76.178055",
        "iso": "BS",
        "status": 1,
        "name": "Rock Sound Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "24.891666",
        "size": "medium"
    },
    {
        "iata": "RKS",
        "lon": "-109.065834",
        "iso": "US",
        "status": 1,
        "name": "Rock Springs Sweetwater County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.59639",
        "size": "medium"
    },
    {
        "iata": "RWI",
        "lon": "-77.89056",
        "iso": "US",
        "status": 1,
        "name": "Rocky Mount Wilson Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.854443",
        "size": "medium"
    },
    {
        "iata": "MFR",
        "lon": "-122.87312",
        "iso": "US",
        "status": 1,
        "name": "Rogue Valley International Medford Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.369026",
        "size": "medium"
    },
    {
        "iata": "DCA",
        "lon": "-77.04346",
        "iso": "US",
        "status": 1,
        "name": "Ronald Reagan Washington National Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.853436",
        "size": "large"
    },
    {
        "iata": "YDM",
        "lon": "138.8216",
        "iso": "CA",
        "status": 1,
        "name": "Ross River Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "-17.939201",
        "size": "medium"
    },
    {
        "iata": "ROW",
        "lon": "-104.53",
        "iso": "US",
        "status": 1,
        "name": "Roswell International Air Center Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.29972",
        "size": "medium"
    },
    {
        "iata": "ZRJ",
        "lon": "-91.316666",
        "iso": "CA",
        "status": 1,
        "name": "Round Lake (Weagamow Lake) Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.95",
        "size": "medium"
    },
    {
        "iata": "YUY",
        "lon": "-78.83056",
        "iso": "CA",
        "status": 1,
        "name": "Rouyn Noranda Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.205555",
        "size": "medium"
    },
    {
        "iata": "RUV",
        "lon": "-90.333336",
        "iso": "GT",
        "status": 1,
        "name": "Rubelsanto Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "15.833333",
        "size": "medium"
    },
    {
        "iata": "SYP",
        "lon": "-80.98333",
        "iso": "PA",
        "status": 1,
        "name": "Ruben Cantu Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "8.1",
        "size": "medium"
    },
    {
        "iata": "RBY",
        "lon": "-155.46083",
        "iso": "US",
        "status": 1,
        "name": "Ruby Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.73",
        "size": "medium"
    },
    {
        "iata": "RUT",
        "lon": "-72.94833",
        "iso": "US",
        "status": 1,
        "name": "Rutland - Southern Vermont Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.529446",
        "size": "medium"
    },
    {
        "iata": "ZPB",
        "lon": "-92.195274",
        "iso": "CA",
        "status": 1,
        "name": "Sachigo Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.890556",
        "size": "medium"
    },
    {
        "iata": "YSY",
        "lon": "-125.24104",
        "iso": "CA",
        "status": 1,
        "name": "Sachs Harbour (David Nasogaluak Jr. Saaryuaq) Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "71.99145",
        "size": "medium"
    },
    {
        "iata": "SMF",
        "lon": "-121.5937",
        "iso": "US",
        "status": 1,
        "name": "Sacramento International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.692284",
        "size": "large"
    },
    {
        "iata": "YSJ",
        "lon": "-65.8902",
        "iso": "CA",
        "status": 1,
        "name": "Saint John Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.32948",
        "size": "medium"
    },
    {
        "iata": "SLN",
        "lon": "-97.6525",
        "iso": "US",
        "status": 1,
        "name": "Salina Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.790833",
        "size": "medium"
    },
    {
        "iata": "SBY",
        "lon": "-75.517265",
        "iso": "US",
        "status": 1,
        "name": "Salisbury Ocean City Wicomico Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.34312",
        "size": "medium"
    },
    {
        "iata": "YZG",
        "lon": "-75.63333",
        "iso": "CA",
        "status": 1,
        "name": "Salluit Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.2",
        "size": "medium"
    },
    {
        "iata": "YSN",
        "lon": "-119.23333",
        "iso": "CA",
        "status": 1,
        "name": "Salmon Arm Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.683334",
        "size": "medium"
    },
    {
        "iata": "SLC",
        "lon": "-111.980675",
        "iso": "US",
        "status": 1,
        "name": "Salt Lake City International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.785645",
        "size": "large"
    },
    {
        "iata": "SAQ",
        "lon": "-78.05",
        "iso": "BS",
        "status": 1,
        "name": "San Andros Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.05",
        "size": "medium"
    },
    {
        "iata": "SJT",
        "lon": "-100.494446",
        "iso": "US",
        "status": 1,
        "name": "San Angelo Regional Mathis Field",
        "continent": "NA",
        "type": "airport",
        "lat": "31.359722",
        "size": "medium"
    },
    {
        "iata": "SAT",
        "lon": "-98.47264",
        "iso": "US",
        "status": 1,
        "name": "San Antonio International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "29.524937",
        "size": "large"
    },
    {
        "iata": "SAN",
        "lon": "-117.19731",
        "iso": "US",
        "status": 1,
        "name": "San Diego International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.731937",
        "size": "large"
    },
    {
        "iata": "SFO",
        "lon": "-122.38988",
        "iso": "US",
        "status": 1,
        "name": "San Francisco International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.615215",
        "size": "large"
    },
    {
        "iata": "SNJ",
        "lon": "-84.15",
        "iso": "CU",
        "status": 1,
        "name": "San Julian Air Base",
        "continent": "NA",
        "type": "airport",
        "lat": "22.083332",
        "size": "medium"
    },
    {
        "iata": "SBP",
        "lon": "-120.640625",
        "iso": "US",
        "status": 1,
        "name": "San Luis County Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.239113",
        "size": "medium"
    },
    {
        "iata": "ALS",
        "lon": "-105.86667",
        "iso": "US",
        "status": 1,
        "name": "San Luis Valley Regional Bergman Field",
        "continent": "NA",
        "type": "airport",
        "lat": "37.43667",
        "size": "medium"
    },
    {
        "iata": "QSN",
        "iso": "CU",
        "status": 1,
        "name": "San Nicolas De Bari Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "SPR",
        "lon": "-87.96571",
        "iso": "BZ",
        "status": 1,
        "name": "San Pedro Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.917067",
        "size": "medium"
    },
    {
        "iata": "ZSA",
        "lon": "-74.53306",
        "iso": "BS",
        "status": 1,
        "name": "San Salvador Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "24.06",
        "size": "medium"
    },
    {
        "iata": "TOO",
        "lon": "-82.96667",
        "iso": "CR",
        "status": 1,
        "name": "San Vito De Java Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "8.833333",
        "size": "medium"
    },
    {
        "iata": "SDP",
        "lon": "-160.51389",
        "iso": "US",
        "status": 1,
        "name": "Sand Point Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.316666",
        "size": "medium"
    },
    {
        "iata": "YZP",
        "lon": "-131.81277",
        "iso": "CA",
        "status": 1,
        "name": "Sandspit Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.254444",
        "size": "medium"
    },
    {
        "iata": "ZSJ",
        "lon": "-93.23333",
        "iso": "CA",
        "status": 1,
        "name": "Sandy Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.033333",
        "size": "medium"
    },
    {
        "iata": "MBJ",
        "lon": "-77.91663",
        "iso": "JM",
        "status": 1,
        "name": "Sangster International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.498465",
        "size": "medium"
    },
    {
        "iata": "YSK",
        "lon": "-79.21667",
        "iso": "CA",
        "status": 1,
        "name": "Sanikiluaq Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.55",
        "size": "medium"
    },
    {
        "iata": "SBA",
        "lon": "-119.83648",
        "iso": "US",
        "status": 1,
        "name": "Santa Barbara Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "34.432835",
        "size": "medium"
    },
    {
        "iata": "SMX",
        "lon": "-120.45778",
        "iso": "US",
        "status": 1,
        "name": "Santa Maria Pub/Capt G Allan Hancock Field",
        "continent": "NA",
        "type": "airport",
        "lat": "34.905",
        "size": "medium"
    },
    {
        "iata": "SRQ",
        "lon": "-82.55328",
        "iso": "US",
        "status": 1,
        "name": "Sarasota Bradenton International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "27.38748",
        "size": "large"
    },
    {
        "iata": "SJX",
        "lon": "-88.333336",
        "iso": "BZ",
        "status": 1,
        "name": "Sartaneja Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.3",
        "size": "medium"
    },
    {
        "iata": "YXE",
        "lon": "-106.69037",
        "iso": "CA",
        "status": 1,
        "name": "Saskatoon John G. Diefenbaker International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.169704",
        "size": "medium"
    },
    {
        "iata": "YAM",
        "lon": "-84.49995",
        "iso": "CA",
        "status": 1,
        "name": "Sault Ste Marie Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.485302",
        "size": "medium"
    },
    {
        "iata": "SAV",
        "lon": "-81.21059",
        "iso": "US",
        "status": 1,
        "name": "Savannah Hilton Head International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.1358",
        "size": "large"
    },
    {
        "iata": "SVA",
        "lon": "-170.48679",
        "iso": "US",
        "status": 1,
        "name": "Savoonga Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "63.69093",
        "size": "medium"
    },
    {
        "iata": "YKL",
        "lon": "-64.816666",
        "iso": "CA",
        "status": 1,
        "name": "Schefferville Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.783333",
        "size": "medium"
    },
    {
        "iata": "GLS",
        "lon": "-94.860275",
        "iso": "US",
        "status": 1,
        "name": "Scholes International At Galveston Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "29.2675",
        "size": "medium"
    },
    {
        "iata": "SEA",
        "lon": "-122.301735",
        "iso": "US",
        "status": 1,
        "name": "Seattle Tacoma International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.44384",
        "size": "large"
    },
    {
        "iata": "SWD",
        "lon": "-149.41806",
        "iso": "US",
        "status": 1,
        "name": "Seward Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.13333",
        "size": "medium"
    },
    {
        "iata": "ZTM",
        "lon": "-92.08035",
        "iso": "CA",
        "status": 1,
        "name": "Shamattawa Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.858505",
        "size": "medium"
    },
    {
        "iata": "SPS",
        "lon": "-98.49194",
        "iso": "US",
        "status": 1,
        "name": "Sheppard Air Force Base-Wichita Falls Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.988335",
        "size": "large"
    },
    {
        "iata": "YSC",
        "lon": "-71.9",
        "iso": "CA",
        "status": 1,
        "name": "Sherbrooke Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.416668",
        "size": "medium"
    },
    {
        "iata": "SHR",
        "lon": "-106.97722",
        "iso": "US",
        "status": 1,
        "name": "Sheridan County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.774166",
        "size": "medium"
    },
    {
        "iata": "SHH",
        "lon": "-166.05833",
        "iso": "US",
        "status": 1,
        "name": "Shishmaref Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "66.25694",
        "size": "medium"
    },
    {
        "iata": "SHV",
        "lon": "-93.828384",
        "iso": "US",
        "status": 1,
        "name": "Shreveport Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.45471",
        "size": "large"
    },
    {
        "iata": "MZO",
        "lon": "-77.12889",
        "iso": "CU",
        "status": 1,
        "name": "Sierra Maestra Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.325",
        "size": "medium"
    },
    {
        "iata": "FHU",
        "lon": "-110.343056",
        "iso": "US",
        "status": 1,
        "name": "Sierra Vista Municipal Libby Army Air Field",
        "continent": "NA",
        "type": "airport",
        "lat": "31.588888",
        "size": "medium"
    },
    {
        "iata": "SZJ",
        "lon": "-82.954445",
        "iso": "CU",
        "status": 1,
        "name": "Siguanea Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.643059",
        "size": "medium"
    },
    {
        "iata": "FBG",
        "lon": "-78.936386",
        "iso": "US",
        "status": 1,
        "name": "Simmons Army Air Field",
        "continent": "NA",
        "type": "airport",
        "lat": "35.131943",
        "size": "medium"
    },
    {
        "iata": "SUX",
        "lon": "-96.38417",
        "iso": "US",
        "status": 1,
        "name": "Sioux Gateway Col. Bud Day Field",
        "continent": "NA",
        "type": "airport",
        "lat": "42.401943",
        "size": "large"
    },
    {
        "iata": "YXL",
        "lon": "-91.903",
        "iso": "CA",
        "status": 1,
        "name": "Sioux Lookout Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.115208",
        "size": "medium"
    },
    {
        "iata": "BGI",
        "lon": "-59.487835",
        "iso": "BB",
        "status": 1,
        "name": "Sir Grantley Adams International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "13.080732",
        "size": "medium"
    },
    {
        "iata": "SIT",
        "lon": "-135.23334",
        "iso": "US",
        "status": 1,
        "name": "Sitka Rocky Gutierrez Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "57.04861",
        "size": "medium"
    },
    {
        "iata": "YZH",
        "lon": "-114.78333",
        "iso": "CA",
        "status": 1,
        "name": "Slave Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.3",
        "size": "medium"
    },
    {
        "iata": "INT",
        "lon": "-80.225555",
        "iso": "US",
        "status": 1,
        "name": "Smith Reynolds Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "36.135277",
        "size": "medium"
    },
    {
        "iata": "YYD",
        "lon": "-127.180275",
        "iso": "CA",
        "status": 1,
        "name": "Smithers Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.825558",
        "size": "medium"
    },
    {
        "iata": "YSH",
        "lon": "-75.93959",
        "iso": "CA",
        "status": 1,
        "name": "Smiths Falls-Montague (Russ Beach) Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.94829",
        "size": "medium"
    },
    {
        "iata": "PAE",
        "lon": "-122.28445",
        "iso": "US",
        "status": 1,
        "name": "Snohomish County (Paine Field) Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.90972",
        "size": "medium"
    },
    {
        "iata": "SXQ",
        "lon": "-151.03639",
        "iso": "US",
        "status": 1,
        "name": "Soldotna Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.475555",
        "size": "medium"
    },
    {
        "iata": "ELD",
        "lon": "-92.81472",
        "iso": "US",
        "status": 1,
        "name": "South Arkansas Regional At Goodwin Field",
        "continent": "NA",
        "type": "airport",
        "lat": "33.220554",
        "size": "medium"
    },
    {
        "iata": "SBN",
        "lon": "-86.31335",
        "iso": "US",
        "status": 1,
        "name": "South Bend Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.700554",
        "size": "large"
    },
    {
        "iata": "BIM",
        "lon": "-79.26399",
        "iso": "BS",
        "status": 1,
        "name": "South Bimini Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.700066",
        "size": "medium"
    },
    {
        "iata": "XSC",
        "lon": "-71.529724",
        "iso": "TC",
        "status": 1,
        "name": "South Caicos Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.515833",
        "size": "medium"
    },
    {
        "iata": "ZSN",
        "iso": "CA",
        "status": 1,
        "name": "South Indian Lake Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "BRL",
        "lon": "-91.12334",
        "iso": "US",
        "status": 1,
        "name": "Southeast Iowa Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.78611",
        "size": "medium"
    },
    {
        "iata": "BPT",
        "lon": "-94.02",
        "iso": "US",
        "status": 1,
        "name": "Southeast Texas Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "29.950832",
        "size": "medium"
    },
    {
        "iata": "MDH",
        "lon": "-89.24694",
        "iso": "US",
        "status": 1,
        "name": "Southern Illinois Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.781387",
        "size": "medium"
    },
    {
        "iata": "YPG",
        "lon": "-98.3",
        "iso": "CA",
        "status": 1,
        "name": "Southport Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.966667",
        "size": "medium"
    },
    {
        "iata": "RSW",
        "lon": "-81.75433",
        "iso": "US",
        "status": 1,
        "name": "Southwest Florida International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "26.542835",
        "size": "large"
    },
    {
        "iata": "ABY",
        "lon": "-84.19611",
        "iso": "US",
        "status": 1,
        "name": "Southwest Georgia Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "31.532223",
        "size": "medium"
    },
    {
        "iata": "OTH",
        "lon": "-124.24",
        "iso": "US",
        "status": 1,
        "name": "Southwest Oregon Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.418888",
        "size": "medium"
    },
    {
        "iata": "SVW",
        "lon": "-155.57222",
        "iso": "US",
        "status": 1,
        "name": "Sparrevohn Lrrs Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "61.0975",
        "size": "medium"
    },
    {
        "iata": "GEG",
        "lon": "-117.537636",
        "iso": "US",
        "status": 1,
        "name": "Spokane International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.62515",
        "size": "large"
    },
    {
        "iata": "AXP",
        "lon": "-73.96667",
        "iso": "BS",
        "status": 1,
        "name": "Spring Point Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "22.45",
        "size": "medium"
    },
    {
        "iata": "SGF",
        "lon": "-93.38226",
        "iso": "US",
        "status": 1,
        "name": "Springfield Branson National Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.24237",
        "size": "large"
    },
    {
        "iata": "YAY",
        "lon": "-55.583332",
        "iso": "CA",
        "status": 1,
        "name": "St Anthony Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.36667",
        "size": "medium"
    },
    {
        "iata": "YIF",
        "lon": "-58.666668",
        "iso": "CA",
        "status": 1,
        "name": "St Augustin Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.216667",
        "size": "medium"
    },
    {
        "iata": "STC",
        "lon": "-94.166664",
        "iso": "US",
        "status": 1,
        "name": "St Cloud Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.55",
        "size": "medium"
    },
    {
        "iata": "PBV",
        "lon": "-57.333332",
        "iso": "US",
        "status": 1,
        "name": "St George Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "-11.516667",
        "size": "medium"
    },
    {
        "iata": "YJN",
        "lon": "-73.333336",
        "iso": "CA",
        "status": 1,
        "name": "St Jean Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "45.333332",
        "size": "medium"
    },
    {
        "iata": "YYT",
        "lon": "-52.74334",
        "iso": "CA",
        "status": 1,
        "name": "St Johns International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.61282",
        "size": "medium"
    },
    {
        "iata": "YSL",
        "lon": "-67.9",
        "iso": "CA",
        "status": 1,
        "name": "St Leonard Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.183334",
        "size": "medium"
    },
    {
        "iata": "ALN",
        "lon": "-90.04833",
        "iso": "US",
        "status": 1,
        "name": "St Louis Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.891666",
        "size": "medium"
    },
    {
        "iata": "FPR",
        "lon": "-80.333336",
        "iso": "US",
        "status": 1,
        "name": "St Lucie County International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "27.45",
        "size": "medium"
    },
    {
        "iata": "KSM",
        "lon": "-163.29489",
        "iso": "US",
        "status": 1,
        "name": "St Mary's Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.058666",
        "size": "medium"
    },
    {
        "iata": "STP",
        "lon": "-93.066666",
        "iso": "US",
        "status": 1,
        "name": "St Paul Downtown Holman Field",
        "continent": "NA",
        "type": "airport",
        "lat": "44.933334",
        "size": "medium"
    },
    {
        "iata": "SNP",
        "lon": "-170.21722",
        "iso": "US",
        "status": 1,
        "name": "St Paul Island Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "57.15222",
        "size": "medium"
    },
    {
        "iata": "PIE",
        "lon": "-82.69511",
        "iso": "US",
        "status": 1,
        "name": "St Petersburg Clearwater International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "27.912004",
        "size": "medium"
    },
    {
        "iata": "FSP",
        "lon": "-56.166668",
        "iso": "PM",
        "status": 1,
        "name": "St Pierre Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.916668",
        "size": "medium"
    },
    {
        "iata": "YQS",
        "lon": "-81.2",
        "iso": "CA",
        "status": 1,
        "name": "St Thomas Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.783333",
        "size": "medium"
    },
    {
        "iata": "YST",
        "lon": "-94.8516",
        "iso": "CA",
        "status": 1,
        "name": "St. Theresa Point Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.846127",
        "size": "medium"
    },
    {
        "iata": "TYM",
        "lon": "-76.433334",
        "iso": "BS",
        "status": 1,
        "name": "Staniel Cay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "24.15",
        "size": "medium"
    },
    {
        "iata": "SML",
        "lon": "-75.26806",
        "iso": "BS",
        "status": 1,
        "name": "Stella Maris Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "23.583332",
        "size": "medium"
    },
    {
        "iata": "YJT",
        "lon": "-58.55",
        "iso": "CA",
        "status": 1,
        "name": "Stephenville Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.533333",
        "size": "medium"
    },
    {
        "iata": "SWF",
        "lon": "-74.10104",
        "iso": "US",
        "status": 1,
        "name": "Stewart International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.49843",
        "size": "medium"
    },
    {
        "iata": "YSF",
        "lon": "-105.83657",
        "iso": "CA",
        "status": 1,
        "name": "Stony Rapids Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "59.251163",
        "size": "medium"
    },
    {
        "iata": "YSB",
        "lon": "-80.79592",
        "iso": "CA",
        "status": 1,
        "name": "Sudbury Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.62296",
        "size": "medium"
    },
    {
        "iata": "YSU",
        "lon": "-57.983334",
        "iso": "CA",
        "status": 1,
        "name": "Summerside Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.0",
        "size": "medium"
    },
    {
        "iata": "ZJN",
        "lon": "-101.23333",
        "iso": "CA",
        "status": 1,
        "name": "Swan River Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.11667",
        "size": "medium"
    },
    {
        "iata": "YYN",
        "lon": "-107.833336",
        "iso": "CA",
        "status": 1,
        "name": "Swift Current Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.283333",
        "size": "medium"
    },
    {
        "iata": "YQY",
        "lon": "-60.05",
        "iso": "CA",
        "status": 1,
        "name": "Sydney / J.A. Douglas McCurdy Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.166668",
        "size": "medium"
    },
    {
        "iata": "SYR",
        "lon": "-76.11223",
        "iso": "US",
        "status": 1,
        "name": "Syracuse Hancock International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.113983",
        "size": "large"
    },
    {
        "iata": "XTL",
        "lon": "-98.51344",
        "iso": "CA",
        "status": 1,
        "name": "Tadoule Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.707954",
        "size": "medium"
    },
    {
        "iata": "TLH",
        "lon": "-84.34444",
        "iso": "US",
        "status": 1,
        "name": "Tallahassee Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "30.395782",
        "size": "large"
    },
    {
        "iata": "YYH",
        "lon": "-93.51667",
        "iso": "CA",
        "status": 1,
        "name": "Taloyoak Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "69.53333",
        "size": "medium"
    },
    {
        "iata": "TPA",
        "lon": "-82.535416",
        "iso": "US",
        "status": 1,
        "name": "Tampa International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "27.97987",
        "size": "large"
    },
    {
        "iata": "TAP",
        "lon": "-92.25306",
        "iso": "MX",
        "status": 1,
        "name": "Tapachula International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "14.909722",
        "size": "medium"
    },
    {
        "iata": "YTQ",
        "lon": "-69.95633",
        "iso": "CA",
        "status": 1,
        "name": "Tasiujaq Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.6678",
        "size": "medium"
    },
    {
        "iata": "TLJ",
        "lon": "-155.96806",
        "iso": "US",
        "status": 1,
        "name": "Tatalina LRRS Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.885277",
        "size": "medium"
    },
    {
        "iata": "ANC",
        "lon": "-149.99638",
        "iso": "US",
        "status": 1,
        "name": "Ted Stevens Anchorage International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "61.174442",
        "size": "large"
    },
    {
        "iata": "TEA",
        "lon": "-87.48778",
        "iso": "HN",
        "status": 1,
        "name": "Tela Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "15.771667",
        "size": "medium"
    },
    {
        "iata": "YXT",
        "lon": "-128.57445",
        "iso": "CA",
        "status": 1,
        "name": "Terrace Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.465557",
        "size": "medium"
    },
    {
        "iata": "EIS",
        "lon": "-64.54278",
        "iso": "VG",
        "status": 1,
        "name": "Terrance B. Lettsome International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.44389",
        "size": "medium"
    },
    {
        "iata": "HUF",
        "lon": "-87.3075",
        "iso": "US",
        "status": 1,
        "name": "Terre Haute International Hulman Field",
        "continent": "NA",
        "type": "airport",
        "lat": "39.454445",
        "size": "medium"
    },
    {
        "iata": "YZW",
        "lon": "-132.71666",
        "iso": "CA",
        "status": 1,
        "name": "Teslin Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.166668",
        "size": "medium"
    },
    {
        "iata": "YGB",
        "lon": "-124.53333",
        "iso": "CA",
        "status": 1,
        "name": "Texada Gillies Bay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.7",
        "size": "medium"
    },
    {
        "iata": "TXK",
        "lon": "-93.98917",
        "iso": "US",
        "status": 1,
        "name": "Texarkana Regional Webb Field",
        "continent": "NA",
        "type": "airport",
        "lat": "33.45639",
        "size": "medium"
    },
    {
        "iata": "CID",
        "lon": "-91.7003",
        "iso": "US",
        "status": 1,
        "name": "The Eastern Iowa Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.889423",
        "size": "large"
    },
    {
        "iata": "YQD",
        "lon": "-101.1",
        "iso": "CA",
        "status": 1,
        "name": "The Pas Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.966667",
        "size": "medium"
    },
    {
        "iata": "PVD",
        "lon": "-71.43632",
        "iso": "US",
        "status": 1,
        "name": "Theodore Francis Green State Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.72631",
        "size": "medium"
    },
    {
        "iata": "YTD",
        "lon": "-97.7",
        "iso": "CA",
        "status": 1,
        "name": "Thicket Portage Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.316666",
        "size": "medium"
    },
    {
        "iata": "YTH",
        "lon": "-97.8605",
        "iso": "CA",
        "status": 1,
        "name": "Thompson Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "55.79753",
        "size": "medium"
    },
    {
        "iata": "THU",
        "lon": "-68.7",
        "iso": "GL",
        "status": 1,
        "name": "Thule Air Base",
        "continent": "NA",
        "type": "airport",
        "lat": "76.53333",
        "size": "medium"
    },
    {
        "iata": "YQT",
        "lon": "-89.31167",
        "iso": "CA",
        "status": 1,
        "name": "Thunder Bay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.37184",
        "size": "medium"
    },
    {
        "iata": "YTS",
        "lon": "-81.37164",
        "iso": "CA",
        "status": 1,
        "name": "Timmins/Victor M. Power",
        "continent": "NA",
        "type": "airport",
        "lat": "48.566372",
        "size": "medium"
    },
    {
        "iata": "KTP",
        "lon": "-76.82333",
        "iso": "JM",
        "status": 1,
        "name": "Tinson Pen Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.9875",
        "size": "medium"
    },
    {
        "iata": "TAB",
        "lon": "-60.839684",
        "iso": "TT",
        "status": 1,
        "name": "Tobago-Crown Point Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "11.152541",
        "size": "medium"
    },
    {
        "iata": "SYQ",
        "lon": "-84.13333",
        "iso": "CR",
        "status": 1,
        "name": "Tobias Bolanos International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "9.95",
        "size": "medium"
    },
    {
        "iata": "PTY",
        "lon": "-79.38764",
        "iso": "PA",
        "status": 1,
        "name": "Tocumen International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "9.066897",
        "size": "large"
    },
    {
        "iata": "YAZ",
        "lon": "-125.77639",
        "iso": "CA",
        "status": 1,
        "name": "Tofino / Long Beach Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.076942",
        "size": "medium"
    },
    {
        "iata": "TOG",
        "lon": "-160.38222",
        "iso": "US",
        "status": 1,
        "name": "Togiak Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "59.056667",
        "size": "medium"
    },
    {
        "iata": "TOL",
        "lon": "-83.8069",
        "iso": "US",
        "status": 1,
        "name": "Toledo Express Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.5925",
        "size": "large"
    },
    {
        "iata": "PAP",
        "lon": "-72.29471",
        "iso": "HT",
        "status": 1,
        "name": "Toussaint Louverture International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.575394",
        "size": "medium"
    },
    {
        "iata": "TCB",
        "lon": "-77.37222",
        "iso": "BS",
        "status": 1,
        "name": "Treasure Cay Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "26.735",
        "size": "medium"
    },
    {
        "iata": "TTN",
        "lon": "-74.8125",
        "iso": "US",
        "status": 1,
        "name": "Trenton Mercer Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.278057",
        "size": "medium"
    },
    {
        "iata": "PSC",
        "lon": "-119.1152",
        "iso": "US",
        "status": 1,
        "name": "Tri Cities Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.259094",
        "size": "medium"
    },
    {
        "iata": "TRI",
        "lon": "-82.40785",
        "iso": "US",
        "status": 1,
        "name": "Tri Cities Regional Tn Va Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "36.48111",
        "size": "large"
    },
    {
        "iata": "HTS",
        "lon": "-82.556114",
        "iso": "US",
        "status": 1,
        "name": "Tri-State/Milton J. Ferguson Field",
        "continent": "NA",
        "type": "airport",
        "lat": "38.366943",
        "size": "large"
    },
    {
        "iata": "TJI",
        "lon": "-85.939445",
        "iso": "HN",
        "status": 1,
        "name": "Trujillo Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "15.925833",
        "size": "medium"
    },
    {
        "iata": "TUS",
        "lon": "-110.93737",
        "iso": "US",
        "status": 1,
        "name": "Tucson International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.12069",
        "size": "large"
    },
    {
        "iata": "YUB",
        "lon": "-133.025",
        "iso": "CA",
        "status": 1,
        "name": "Tuktoyaktuk Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "69.436386",
        "size": "medium"
    },
    {
        "iata": "ZFN",
        "lon": "-125.566666",
        "iso": "CA",
        "status": 1,
        "name": "Tulita Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "64.916664",
        "size": "medium"
    },
    {
        "iata": "TUL",
        "lon": "-95.8901",
        "iso": "US",
        "status": 1,
        "name": "Tulsa International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "36.189808",
        "size": "large"
    },
    {
        "iata": "TUP",
        "lon": "-88.76722",
        "iso": "US",
        "status": 1,
        "name": "Tupelo Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "34.25889",
        "size": "medium"
    },
    {
        "iata": "TCL",
        "lon": "-87.61083",
        "iso": "US",
        "status": 1,
        "name": "Tuscaloosa Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "33.22111",
        "size": "medium"
    },
    {
        "iata": "HVN",
        "lon": "-72.888336",
        "iso": "US",
        "status": 1,
        "name": "Tweed New Haven Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.265278",
        "size": "medium"
    },
    {
        "iata": "TYR",
        "lon": "-95.41012",
        "iso": "US",
        "status": 1,
        "name": "Tyler Pounds Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.351597",
        "size": "medium"
    },
    {
        "iata": "YHI",
        "lon": "-117.71667",
        "iso": "CA",
        "status": 1,
        "name": "Ulukhaktok Holman Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "70.71667",
        "size": "medium"
    },
    {
        "iata": "YUD",
        "lon": "-76.51833",
        "iso": "CA",
        "status": 1,
        "name": "Umiujaq Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.53611",
        "size": "medium"
    },
    {
        "iata": "DUT",
        "lon": "-166.54224",
        "iso": "US",
        "status": 1,
        "name": "Unalaska Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.89446",
        "size": "medium"
    },
    {
        "iata": "UNI",
        "lon": "-61.0",
        "iso": "VC",
        "status": 1,
        "name": "Union Island International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "13.5",
        "size": "medium"
    },
    {
        "iata": "CMI",
        "lon": "-88.26905",
        "iso": "US",
        "status": 1,
        "name": "University of Illinois Willard Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.039665",
        "size": "medium"
    },
    {
        "iata": "SCE",
        "lon": "-77.84823",
        "iso": "US",
        "status": 1,
        "name": "University Park Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "40.85372",
        "size": "medium"
    },
    {
        "iata": "UPL",
        "lon": "-85.03333",
        "iso": "CR",
        "status": 1,
        "name": "Upala Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "10.783333",
        "size": "medium"
    },
    {
        "iata": "UPP",
        "lon": "-155.8625",
        "iso": "US",
        "status": 1,
        "name": "Upolu Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.268057",
        "size": "medium"
    },
    {
        "iata": "YBE",
        "lon": "-108.48333",
        "iso": "CA",
        "status": 1,
        "name": "Uranium City Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "59.566666",
        "size": "medium"
    },
    {
        "iata": "ANU",
        "lon": "-61.76389",
        "iso": "AG",
        "status": 1,
        "name": "V.C. Bird International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.108334",
        "size": "medium"
    },
    {
        "iata": "YVO",
        "lon": "-77.78858",
        "iso": "CA",
        "status": 1,
        "name": "Val-d'Or Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.052605",
        "size": "medium"
    },
    {
        "iata": "VDZ",
        "lon": "-146.23889",
        "iso": "US",
        "status": 1,
        "name": "Valdez Pioneer Field",
        "continent": "NA",
        "type": "airport",
        "lat": "61.1325",
        "size": "medium"
    },
    {
        "iata": "VLD",
        "lon": "-83.27722",
        "iso": "US",
        "status": 1,
        "name": "Valdosta Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "30.78389",
        "size": "medium"
    },
    {
        "iata": "LMM",
        "lon": "-108.98333",
        "iso": "MX",
        "status": 1,
        "name": "Valle del Fuerte International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "25.816668",
        "size": "medium"
    },
    {
        "iata": "HRL",
        "lon": "-97.662254",
        "iso": "US",
        "status": 1,
        "name": "Valley International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "26.223482",
        "size": "medium"
    },
    {
        "iata": "NEV",
        "lon": "-62.5925",
        "iso": "KN",
        "status": 1,
        "name": "Vance W. Amory International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "17.205",
        "size": "medium"
    },
    {
        "iata": "YVR",
        "lon": "-123.17919",
        "iso": "CA",
        "status": 1,
        "name": "Vancouver International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.1947",
        "size": "large"
    },
    {
        "iata": "YVE",
        "lon": "-119.333336",
        "iso": "CA",
        "status": 1,
        "name": "Vernon Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "50.25",
        "size": "medium"
    },
    {
        "iata": "VRB",
        "lon": "-80.41361",
        "iso": "US",
        "status": 1,
        "name": "Vero Beach Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "27.6525",
        "size": "medium"
    },
    {
        "iata": "YYJ",
        "lon": "-123.43096",
        "iso": "CA",
        "status": 1,
        "name": "Victoria International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.640266",
        "size": "large"
    },
    {
        "iata": "VCT",
        "lon": "-96.914444",
        "iso": "US",
        "status": 1,
        "name": "Victoria Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "28.85111",
        "size": "medium"
    },
    {
        "iata": "CYO",
        "lon": "-81.51667",
        "iso": "CU",
        "status": 1,
        "name": "Vilo Acuna International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "21.616667",
        "size": "medium"
    },
    {
        "iata": "YVD",
        "lon": "146.18889",
        "iso": "CA",
        "status": 1,
        "name": "Virden/R.J. (Bob) Andrew Field Regional Aerodrome",
        "continent": "NA",
        "type": "airport",
        "lat": "-7.55",
        "size": "medium"
    },
    {
        "iata": "YWK",
        "lon": "-66.874",
        "iso": "CA",
        "status": 1,
        "name": "Wabush Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.926315",
        "size": "medium"
    },
    {
        "iata": "ACT",
        "lon": "-97.22321",
        "iso": "US",
        "status": 1,
        "name": "Waco Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "31.609133",
        "size": "medium"
    },
    {
        "iata": "MUE",
        "lon": "-155.67334",
        "iso": "US",
        "status": 1,
        "name": "Waimea Kohala Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "20.0125",
        "size": "medium"
    },
    {
        "iata": "AIN",
        "lon": "-160.03334",
        "iso": "US",
        "status": 1,
        "name": "Wainwright Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "70.63333",
        "size": "medium"
    },
    {
        "iata": "ALW",
        "lon": "-118.291115",
        "iso": "US",
        "status": 1,
        "name": "Walla Walla Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "46.094723",
        "size": "medium"
    },
    {
        "iata": "AXA",
        "lon": "-63.066666",
        "iso": "AI",
        "status": 1,
        "name": "Wallblake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "18.216667",
        "size": "medium"
    },
    {
        "iata": "IAD",
        "lon": "-77.44774",
        "iso": "US",
        "status": 1,
        "name": "Washington Dulles International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.95315",
        "size": "large"
    },
    {
        "iata": "IYS",
        "iso": "US",
        "status": 1,
        "name": "Wasilla Airport",
        "continent": "NA",
        "type": "airport",
        "size": "medium"
    },
    {
        "iata": "YKQ",
        "lon": "-78.75",
        "iso": "CA",
        "status": 1,
        "name": "Waskaganish Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.4875",
        "size": "medium"
    },
    {
        "iata": "YKF",
        "lon": "-80.385056",
        "iso": "CA",
        "status": 1,
        "name": "Waterloo Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.458977",
        "size": "medium"
    },
    {
        "iata": "ALO",
        "lon": "-92.39972",
        "iso": "US",
        "status": 1,
        "name": "Waterloo Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.55611",
        "size": "medium"
    },
    {
        "iata": "ART",
        "lon": "-76.021385",
        "iso": "US",
        "status": 1,
        "name": "Watertown International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.990833",
        "size": "medium"
    },
    {
        "iata": "ATY",
        "lon": "-97.15417",
        "iso": "US",
        "status": 1,
        "name": "Watertown Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.90889",
        "size": "medium"
    },
    {
        "iata": "YQH",
        "lon": "-128.825",
        "iso": "CA",
        "status": 1,
        "name": "Watson Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.12361",
        "size": "medium"
    },
    {
        "iata": "YXZ",
        "lon": "-84.785835",
        "iso": "CA",
        "status": 1,
        "name": "Wawa Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "47.9625",
        "size": "medium"
    },
    {
        "iata": "TBN",
        "lon": "-92.14056",
        "iso": "US",
        "status": 1,
        "name": "Waynesville-St. Robert Regional Forney field",
        "continent": "NA",
        "type": "airport",
        "lat": "37.74139",
        "size": "medium"
    },
    {
        "iata": "YWP",
        "lon": "-87.36889",
        "iso": "CA",
        "status": 1,
        "name": "Webequie Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.95972",
        "size": "medium"
    },
    {
        "iata": "YNC",
        "lon": "-78.816666",
        "iso": "CA",
        "status": 1,
        "name": "Wemindji Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "53.0",
        "size": "medium"
    },
    {
        "iata": "HPN",
        "lon": "-73.70389",
        "iso": "US",
        "status": 1,
        "name": "Westchester County Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.068672",
        "size": "medium"
    },
    {
        "iata": "BFF",
        "lon": "-103.60111",
        "iso": "US",
        "status": 1,
        "name": "Western Neb. Rgnl/William B. Heilig Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.87528",
        "size": "medium"
    },
    {
        "iata": "CEF",
        "lon": "-72.55383",
        "iso": "US",
        "status": 1,
        "name": "Westover ARB/Metropolitan Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.183376",
        "size": "medium"
    },
    {
        "iata": "YXN",
        "lon": "-92.6",
        "iso": "CA",
        "status": 1,
        "name": "Whale Cove Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.233334",
        "size": "medium"
    },
    {
        "iata": "HHI",
        "lon": "-158.03334",
        "iso": "US",
        "status": 1,
        "name": "Wheeler Army Airfield",
        "continent": "NA",
        "type": "airport",
        "lat": "21.5",
        "size": "medium"
    },
    {
        "iata": "YZU",
        "lon": "-115.78333",
        "iso": "CA",
        "status": 1,
        "name": "Whitecourt Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "54.15",
        "size": "medium"
    },
    {
        "iata": "YXY",
        "lon": "-135.06667",
        "iso": "CA",
        "status": 1,
        "name": "Whitehorse / Erik Nielsen International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "60.716667",
        "size": "medium"
    },
    {
        "iata": "YVV",
        "lon": "-81.166664",
        "iso": "CA",
        "status": 1,
        "name": "Wiarton Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "44.666668",
        "size": "medium"
    },
    {
        "iata": "ICT",
        "lon": "-97.428955",
        "iso": "US",
        "status": 1,
        "name": "Wichita Mid Continent Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "37.653046",
        "size": "large"
    },
    {
        "iata": "BRW",
        "lon": "-156.77579",
        "iso": "US",
        "status": 1,
        "name": "Wiley Post Will Rogers Memorial Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "71.288574",
        "size": "medium"
    },
    {
        "iata": "AVP",
        "lon": "-75.730644",
        "iso": "US",
        "status": 1,
        "name": "Wilkes Barre Scranton International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.336697",
        "size": "medium"
    },
    {
        "iata": "OKC",
        "lon": "-97.59609",
        "iso": "US",
        "status": 1,
        "name": "Will Rogers World Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "35.39563",
        "size": "large"
    },
    {
        "iata": "HOU",
        "lon": "-95.277016",
        "iso": "US",
        "status": 1,
        "name": "William P Hobby Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "29.654512",
        "size": "large"
    },
    {
        "iata": "CLM",
        "lon": "-123.49511",
        "iso": "US",
        "status": 1,
        "name": "William R Fairchild International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.121883",
        "size": "medium"
    },
    {
        "iata": "YWL",
        "lon": "-122.04444",
        "iso": "CA",
        "status": 1,
        "name": "Williams Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "52.184723",
        "size": "medium"
    },
    {
        "iata": "IPT",
        "lon": "-76.920555",
        "iso": "US",
        "status": 1,
        "name": "Williamsport Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.24222",
        "size": "medium"
    },
    {
        "iata": "YIP",
        "lon": "-83.53333",
        "iso": "US",
        "status": 1,
        "name": "Willow Run Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.233334",
        "size": "medium"
    },
    {
        "iata": "ILM",
        "lon": "-77.91063",
        "iso": "US",
        "status": 1,
        "name": "Wilmington International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "34.26705",
        "size": "medium"
    },
    {
        "iata": "YQG",
        "lon": "-82.96389",
        "iso": "CA",
        "status": 1,
        "name": "Windsor Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.274166",
        "size": "medium"
    },
    {
        "iata": "YWG",
        "lon": "-97.23333",
        "iso": "CA",
        "status": 1,
        "name": "Winnipeg / James Armstrong Richardson International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "49.9",
        "size": "large"
    },
    {
        "iata": "YAV",
        "lon": "-123.3",
        "iso": "CA",
        "status": 1,
        "name": "Winnipeg / St. Andrews Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.86667",
        "size": "medium"
    },
    {
        "iata": "OSH",
        "lon": "-88.556946",
        "iso": "US",
        "status": 1,
        "name": "Wittman Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.98389",
        "size": "medium"
    },
    {
        "iata": "GGW",
        "lon": "-106.615555",
        "iso": "US",
        "status": 1,
        "name": "Wokal Field Glasgow International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "48.212776",
        "size": "medium"
    },
    {
        "iata": "ZWL",
        "lon": "-103.1683",
        "iso": "CA",
        "status": 1,
        "name": "Wollaston Lake Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "58.106743",
        "size": "medium"
    },
    {
        "iata": "ORH",
        "lon": "-71.87444",
        "iso": "US",
        "status": 1,
        "name": "Worcester Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "42.26917",
        "size": "medium"
    },
    {
        "iata": "WRL",
        "lon": "-107.95306",
        "iso": "US",
        "status": 1,
        "name": "Worland Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.9675",
        "size": "medium"
    },
    {
        "iata": "WRG",
        "lon": "-132.36667",
        "iso": "US",
        "status": 1,
        "name": "Wrangell Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.484444",
        "size": "medium"
    },
    {
        "iata": "YWY",
        "lon": "-123.438614",
        "iso": "CA",
        "status": 1,
        "name": "Wrigley Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "63.210556",
        "size": "medium"
    },
    {
        "iata": "YKM",
        "lon": "-120.53778",
        "iso": "US",
        "status": 1,
        "name": "Yakima Air Terminal McAllister Field",
        "continent": "NA",
        "type": "airport",
        "lat": "46.566944",
        "size": "medium"
    },
    {
        "iata": "YQI",
        "lon": "-66.083336",
        "iso": "CA",
        "status": 1,
        "name": "Yarmouth Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "43.833332",
        "size": "medium"
    },
    {
        "iata": "CRW",
        "lon": "-81.596504",
        "iso": "US",
        "status": 1,
        "name": "Yeager Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "38.370342",
        "size": "large"
    },
    {
        "iata": "YZF",
        "lon": "-114.4375",
        "iso": "CA",
        "status": 1,
        "name": "Yellowknife Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "62.470867",
        "size": "medium"
    },
    {
        "iata": "ZAC",
        "lon": "-96.09192",
        "iso": "CA",
        "status": 1,
        "name": "York Landing Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "56.089516",
        "size": "medium"
    },
    {
        "iata": "YQV",
        "lon": "-102.45935",
        "iso": "CA",
        "status": 1,
        "name": "Yorkton Municipal Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "51.264095",
        "size": "medium"
    },
    {
        "iata": "YNG",
        "lon": "-80.66972",
        "iso": "US",
        "status": 1,
        "name": "Youngstown Warren Regional Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "41.25611",
        "size": "medium"
    },
    {
        "iata": "YUM",
        "lon": "-114.599266",
        "iso": "US",
        "status": 1,
        "name": "Yuma MCAS/Yuma International Airport",
        "continent": "NA",
        "type": "airport",
        "lat": "32.668606",
        "size": "medium"
    }
];

